import common from './common'
import featuresPay from './feature'

const ja = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "製品/バリアント",
        serialNumber: "シリアル番号",
        noProductsFound: "製品が見つかりません",
        searchByProductSku: "製品/SKUで検索",
        searchSerialNumbers: "シリアル番号を検索",
        transactionDetails: "取引の詳細",
        notAvailable: "N/A",
        mainWarehouse: "メインウェアハウス"
    },
    new_build_banner: {
        title: '新しいバージョン:',
        is_available: 'が利用可能になりました',
        fallback_title: 'アプリの新しいバージョンが利用可能です',
        desc: '最新の機能と改善を入手するには、更新してください。',
        refreshing: '更新中…',
        refresh_now: '今すぐ更新',
        later: '後で',
        you_are_on: "現在のバージョン"
    },
    short: {
        finance: '財務',
        stock: '在庫'
    },
    onboarding: {
        welcome: 'ようこそ！',
        step: {
            product: {
                totalBreakdown: '合計内訳',
                overallFulfilment: '全体の履行状況',
                totalShippedQty: '発送済み合計数量',
                totalReceivedQty: '受領済み合計数量',
                totalOrderedQty: '注文合計数量',
                totalShippedOrdered: '発送済み / 注文合計',
                totalReceivedOrdered: '受領済み / 注文合計',
                viewQty: '数量を表示',
                fetchingQty: '数量の詳細を取得中...',
                noStockInfo: '在庫情報が見つかりません',
                title: '65％達成',
                description: 'あと2ステップで大成功を始められます！',
                Warehouse: "倉庫",
            },
            stock: {
                title: '95％ほぼ完了！',
                description: 'あと1ステップで大成功を始められます！今すぐ完了しましょう。'
            }
        },
        business: {
            title: 'ビジネスが正常に作成されました！',
            description: '素晴らしい！ビジネスが登録されました'
        },
        product: {
            title: '最初の商品を追加',
            description: '在庫記録を開始するために商品を追加してください',
            Warehouse: "倉庫",
        },
        stock: {
            title: '在庫を追加してみましょう',
            description: '入出庫在庫の記録を開始しましょう'
        },
        action: {
            add_business: {
                title: 'ビジネスを作成',
                description: '新しいビジネスを作成しますか？ここをクリック'
            },
            join_business: {
                title: 'ビジネスに参加',
                description: '招待コードをお持ちですか？ここで参加'
            }
        }
    },
    business: {
        title: 'ビジネスを選択、新規作成、または参加',
        add_business: {
            title: '新しいビジネスを作成',
            name: 'ビジネス名',
            name_placeholder: '名前を入力',
            category: 'ビジネスカテゴリ',
            category_placeholder: 'カテゴリを選択',
            button: 'ビジネスを作成'
        },
        edit_business: {
            title: 'ビジネスを編集'
        },
        join_business: {
            title: 'ビジネスに参加',
            input_code: '下の招待コードを入力してください：',
            field_placeholder: '招待コード',
            confirm_title: '参加',
            confirm_text: '次のチームの一員になります '
        },
        no_business: '利用可能なビジネスはありません',
        create_or_join: 'ビジネスを作成または参加',
        message: {
            saved: 'ビジネスが正常に保存されました！'
        },
        settings: {
            isNegativeTransactionDisabled: 'マイナス在庫取引',
            isNegativeTransactionDisabledHint: 'これをオンにすると、在庫がマイナスになる取引を防ぐことができます。',
            negativeStockError: 'マイナス在庫取引は無効です'
        }
    },
    profile: {
        edit_profile: {
            title: 'プロフィールを編集',
            name: '氏名',
            name_placeholder: '氏名を入力',
            email: 'メール',
            phone_number: '電話番号'
        },
        message: {
            required_name: '名前は必須です'
        }
    },

    product: {
        weightedAverageCost: '加重平均原価',
        weightedAverageValueLabel: '加重平均額',
        Product: '商品',
        hideZeroStock: '在庫ゼロを非表示',
        allVariants: 'すべてのバリエーション',
        choose_product: '商品を選択',
        choose_product_empty: '商品を選択し数量を入力',
        choose_product_empty_manufacturing: '商品を選択し製造数量を入力',
        search: {
            placeholder: '名前で検索',
            tooltip: 'スキャナーを開く',
            Warehouse: "倉庫",
        },
        column: {
            image: '写真',
            name: '名前',
            price: '価格',
            buying_price: '原価',
            selling_price: '販売価格',
            sku: 'SKU',
            stock: '在庫',
            quantity: '数量',
            latest_stock: '残り',
            product_deleted: '商品は削除されました',
            info_not_found: '情報は利用できません',
            expired_date: '有効期限',
            invoice: '請求書'
        },
        no_product: '商品はありません',
        no_product_subtitle: '最初の製品を追加して、在庫、価格設定、および売上の追跡を開始します。',
        create_first_product: '最初の製品を作成する',
        add_product: {
            sku: '商品コード',
            sku_placeholder: '商品コード。例: 12345',
            name: '商品名',
            name_placeholder: '商品名を入力',
            initial_stock: '初期在庫',
            initial_stock_placeholder: '初期在庫を入力',
            buying_price: '原価',
            buying_price_placeholder: '原価を入力',
            selling_price: '販売価格',
            selling_price_placeholder: '販売価格を入力',
            category: 'カテゴリ',
            category_placeholder: 'カテゴリを選択',
            add_selling_price: '卸売価格を追加',
            expired_date: '有効期限',
            expired_date_placeholder: '日付を選択',
            description: '説明',
            description_placeholder: '説明を入力',
            custom_label: '属性',
            custom_label_placeholder: 'キーを入力',
            add_custom_label: '属性を追加',
            Warehouse: "倉庫",
        },
        customerLabel: {},
        choose_selling_price: '販売価格を選択',
        selling_price: '販売価格',
        total_product: '合計商品',
        total_quantity: '総在庫数',
        total_buying_price: '総原価',
        total_selling_price: '総販売価格',
        message: {
            required_name: '商品名は必須です',
            required_sku: 'SKUは必須です',
            required_category: 'カテゴリは必須です',
            required_quantity: '初期在庫は必須です',
            invalid_input_qty: '在庫数量が無効です',
            required_buying_price: '原価は必須です',
            required_selling_price: '販売価格は必須です',
            required_selling_price_name: '販売価格名は必須です',
            required_selling_price_price: '販売価格は必須です'
        },
        viewMore: 'もっと見る',
        WarehouseDetails: '倉庫の詳細',
        WarehouseName: '倉庫名',
        AddWarehouse: '倉庫を追加',
        WarehouseQty: '倉庫数量',
        Warehouse: '倉庫',
        Warehouses: '倉庫',
        Variants: 'バリエーション',
        VariantName: 'バリエーション名',
        productVariant: '商品のバリエーション',
        AddVariant: 'バリエーションを追加',
        TranferItem: 'アイテムを転送',
        AddUnit: '新しい単位',
        InitialStkWarehouse: 'バリエーションを追加するには初期在庫が必要です',
        InitialStockinwarehouse: '倉庫の初期在庫',
        TotalQuantity: '合計数量:',
        AddNote: 'メモを追加（原価）',
        AddNotetitle: 'メモを追加',
        VariantSuccessMessage: '商品バリエーションが正常に更新されました',
        Next: '次へ',
        Submit: '送信',
        INACTIVE: '非アクティブ',
        errorone: 'おっと！要求された数量が',
        errortwo: '割り当てられた倉庫数量と一致しません。数量を調整するか再入庫してください。',
        SelectWarehouse: '倉庫を選択',
        SelectVariant: 'バリエーションを選択',
        Discount: '割引',
        DiscountDetails: '割引詳細',
        FinalPrice: '最終価格',
        DiscountType: '割引タイプ',
        DiscountPer: '割引%',
        DiscountValue: '割引額',
        Discountonprice: '価格に対する割引',
        Discountondiscount: '割引に対する割引',
        AdditionalDiscount: '追加割引',
        SellingPrice: '販売価格：',
        Save: '保存',
        OnOriginalPrice: '元の価格に対して',
        OnDiscountedPrice: '割引価格に対して',
        columnSelector: {
            title: '列の表示',
            columnsButton: '列',
            costPrice: '原価',
            sellingPrice: '販売価格',
            sku: 'SKU',
            warehouse: '倉庫',
            categories: 'カテゴリ',
            safetyStock: '安全在庫',
            attributes: '属性',
            notes: 'メモ',
            description: '説明',
            more: '以上',
            attribute: '属性',
            attributesTitle: '属性',
            categoriesTitle: 'カテゴリ',
            skuAliases: 'SKUエイリアス'
        }
    },
    note: {
        title: 'メモ',
        add: 'メモを追加',
        no_note: '利用可能なメモはありません'
    },

    settings: {
        category: 'カテゴリ',
        language: '言語',
        switch_business: 'ビジネスを切り替える',
        currencySelect: '通貨',
        languageChangeSuccess: '通貨が正常に更新されました',
        languageChangeErrorMessage: '通貨更新中にエラーが発生しました',
        currencyAdded: "通貨が正常に追加されました",
        currencyDelete: "通貨が正常に削除されました",
        Selectyourpreferredlanguage: "希望の言語を選択してください",
    },

    category: {
        category_list: {
            title: '商品カテゴリ'
        },
        add_category: {
            button: '新しいカテゴリ',
            title: '新しいカテゴリを追加'
        },
        edit_category: {
            title: 'カテゴリを編集'
        },
        name: 'カテゴリ名',
        name_placeholder: 'カテゴリ名を入力',
        no_category: 'カテゴリは利用できません'
    },

    staff: {
        add: 'スタッフを追加',
        edit: 'スタッフを編集',
        access: {
            stock: '在庫',
            add_product: '新しい商品を追加',
            edit_product: '商品を編集',
            delete_product: '商品を削除',
            view_capital_price: '原価を表示',
            add_category: '新しいカテゴリを追加',
            edit_category: 'カテゴリを編集',
            delete_category: 'カテゴリを削除',
            add_supplier: '新しいベンダーを追加',
            edit_supplier: 'ベンダーを編集',
            delete_supplier: 'ベンダーを削除',
            add_customer: '新しい顧客を追加',
            edit_customer: '顧客を編集',
            delete_customer: '顧客を削除',
            add_staff: 'スタッフを追加',
            edit_staff: 'スタッフを編集',
            delete_staff: 'スタッフを削除',
            change_business_profile: 'ビジネスプロフィールを変更',
            access_by_product_category: '商品カテゴリ別のアクセス',
            no_category_message: 'カテゴリが追加されていません。カテゴリを追加してください。',
            expenses: '経費',
            view_expenses: '経費を見る',
            add_expenses: '経費を追加',
            edit_expenses: '経費を編集',
            delete_expenses: '経費を削除',
            warehouse: '倉庫',
            add_new_warehouse: '新しい倉庫を追加',
            edit_warehouse: '倉庫を編集',
            delete_warehouse: '倉庫を削除',
            transfer_warehouse: '倉庫を移動',
            transfer_warehouse_approval: '倉庫移動の承認',
            access_by_warehouse: '倉庫別アクセス',
            no_warehouse_message: '倉庫が追加されていません。倉庫リストを追加してください。',
            purchase_order: "購買注文",
            purchase_order_creation: "購買注文の作成",
            purchase_order_edit: "発注書の編集",
            purchase_order_cancel: "発注書のキャンセル",
            purchase_order_reopen: "発注書の再開",
            purchase_order_receive: "購買注文の受領",
            sales_order: "販売注文",
            sales_order_creation: "販売注文の作成",
            sales_order_edit: "受注書の編集",
            sales_order_cancel: "受注書のキャンセル",
            sales_order_reopen: "受注書の再開",
            sales_order_receive: "販売注文の出荷",
            purchase_order_approval: "購買注文の承認",
            sales_order_approval: "販売注文の承認",
            can_do_available_warehouse: "利用可能な倉庫",
            add_batch: "バッチ作成の承認"
            ,
            notification: '通知',
            staffNotification: '通知を有効にする',
            assignee: "担当者",
        },
        no_staff: 'スタッフは利用できません。'
    },

    supplier: {
        add: {
            title: 'ベンダーを追加'
        },
        edit: {
            title: 'ベンダーを編集'
        },
        new: '新しいベンダー',
        no_supplier: 'ベンダーは利用できません。',
        bank: {
            title: '銀行情報'
        },
        note: 'メモ',
        form: {
            name: {
                label: 'ベンダー名',
                placeholder: 'ベンダー名を入力',
                placheolder_not_mandatory: '名前を入力',
                error: {
                    required: '名前を入力してください'
                }
            },
            contact: {
                label: '連絡先番号',
                placeholder: '91934554432',
                error: {
                    required: '連絡先番号は必須です',
                    invalid: '無効な番号です。国番号を含めてください'
                }
            },
            bank_name: {
                label: '銀行名',
                placeholder: '銀行名を入力'
            },
            bank_account_name: {
                label: '口座名義人',
                placeholder: '口座名義人を入力'
            },
            bank_account_number: {
                label: '口座番号',
                placeholder: '口座番号を入力'
            },
            note: {
                label: 'メモ',
                placeholder: 'メモを追加'
            },
            openingBalance: {
                addBtn: '開始残高を追加',
                label: '開始残高',
                placeholder: '開始残高を入力',
                error: {
                    negative: '開始残高をマイナスにすることはできません'
                }
            }
        },
        choose: 'ベンダーを選択'
    },

    customer: {
        add: {
            title: '顧客を追加'
        },
        edit: {
            title: '顧客を編集'
        },
        new: '新しい顧客',
        no_customer: '顧客は利用できません。',
        note: 'メモ',
        form: {
            name: {
                label: '顧客名',
                placeholder: '顧客名を入力',
                placheolder_not_mandatory: '名前を入力',
                error: {
                    required: '名前を入力してください'
                }
            },
            contact: {
                label: '連絡先番号',
                placeholder: '91934554432',
                error: {
                    required: '連絡先番号は必須です',
                    invalid: '無効な番号です。国番号を含めてください'
                }
            },
            address: {
                label: '住所',
                placeholder: '住所を入力'
            },
            note: {
                label: 'メモ',
                placeholder: 'メモを追加'
            },
            openingBalance: {
                addBtn: '開始残高を追加',
                label: '開始残高',
                placeholder: '開始残高を入力',
                error: {
                    negative: '開始残高をマイナスにすることはできません'
                }
            }
        },
        choose: "顧客を選択",
        report: {
            view: '購入者レポートを見る',
            title: '顧客レポート',
            no_report: '選択した日付の購入者レポートはありません。',
            column: {
                name: '名前',
                total_transaction: '総取引数',
                total_amount: '総売上高',
                total_profit: '総利益'
            }
        }
    },
    confirm_delete: 'このデータを削除してもよろしいですか？',

    report: {
        title: 'レポート'
    },

    accounting: {
        download_pdf_report: 'PDFをダウンロード',
        title: '会計',
        view_report: '財務レポートを見る',
        dashboard_title: '財務レポート',
        stats: '統計',
        accounting_report: '会計レポート',
        filter: {
            date: {
                placeholder: '日付を選択',
                submit: '適用',
                cancel: 'フィルタをリセット'
            },
            timeframe: {
                day: '日次',
                week: '週次',
                month: '月次',
                year: '年次'
            }
        },
        total_sales: '総売上高',
        total_purchases: '総仕入額',
        total_profit: '総利益',
        total_expenses: '合計支出',
        assets_value: '現在の資産価値',
        total_current_cogs_value: '現在の総COGS額',
        current_asset_selling_price: '現在の資産販売価格',
        total_selling_price: '総販売価格',
        table: {
            date: '日付',
            sales: '売上',
            purchases: '仕入',
            profit: '利益',
            expenses: '支出'
        },
        no_data: 'データはありません。'
    },

    stock_report: {
        title: '在庫レポート',
        view: '在庫レポートを見る',
        no_report: '選択した日付またはスタッフの在庫記録はありません。',
        allStaffPlaceHolder: '全スタッフ',
        column: {
            total_product: '現在の商品タイプ',
            total_product_quantity: '現在の総商品数'
        }
    },

    subscription: {
        paywall_small: {
            title: 'VIP機能',
            description:
                'この機能の試用期間は終了しました。このローカルアプリの開発をサポートするために、サブスクリプションに登録してください。',
            button: 'サブスクリプションプランを見る'
        }
    },

    payment: {
        order: {
            title: '支払い'
        }
    },

    imageUploadMessage: {
        uploadSize: '画像サイズは5MBを超えてはいけません！',
        failedMessage: '商品画像のアップロードに失敗しました。もう一度お試しください！',
        successUpload: '画像が正常にアップロードされました！',
        failedUIError: '画像の削除に失敗しました。もう一度お試しください！',
        SuccessErrorImage: '画像が正常に削除されました！'
    },

    productColumns: {
        SKULabel: 'SKU',
        nameLabel: '商品名',
        categoryLabel: 'カテゴリ',
        BuyingPriceLabel: '仕入価格',
        SellingLabel: '販売価格',
        StockLabel: '在庫'
    },

    historyColumns: {
        Transactionlabel: '取引タイプ',
        Locallabel: '現地時間',
        Createdlabel: '作成者',
        Vendorlabel: 'ベンダー名',
        Buyerlabel: '購入者名',
        SKUlabel: 'SKU',
        Invoicelabel: '請求書',
        Productlabel: '商品名',
        Categorylabel: 'カテゴリ',
        Buyinglabel: '仕入価格',
        Sellinglabel: '販売価格',
        Initiallabel: '初期在庫',
        Finallabel: '最終在庫',
        Stocklabel: '在庫変動'
    },

    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: '商品名',
        categoryLabel: 'カテゴリ',
        buyingPriceLabel: '仕入価格',
        sellingPriceLabel: '販売価格',
        stockInLabel: '入庫',
        stockOutLabel: '出庫',
        remainingStockLabel: '残り在庫',
        openStockLabel: '初期在庫',
        weightedAverageCost: '加重平均原価',
        weightedAverageCostLabel: '加重平均原価',
        weightedAverageValueLabel: '加重平均額'
    },

    accountingReportColumns: {
        dateRange: '日付範囲',
        reportingPeriod: '報告期間',
        reportGenerate: 'レポート生成',
        warehouse: '倉庫',
        labelDate: '日付',
        labelSales: '売上',
        labelPurchases: '仕入',
        labelProfit: '利益',
        labelExpenses: '経費',
        reportOptions: 'レポート列',
        summaryCards: '概要カード',
        grandTotal: '総計',
        continued: '続く',
        subtotal: '小計',
        page: 'ページ'
    },

    customerReportColumns: {
        labelName: '名前',
        labelTotalTransaction: '総取引数',
        labelTotalSales: '総売上',
        labelTotalProfit: '総利益'
    },

    scannerDialog: {
        finished: '完了',
        reduce: '減らす',
        successfull: '成功',
        searching: '検索中...',
        title: 'スキャナーがアクティブです。バーコードにかざしてください！'
    },

    historyFilter: {
        SelectBuyer: '購入者を選択',
        SelectVendor: 'ベンダーを選択'
    },

    productStockFilter: {
        StockLowtoHigh: '在庫少→多',
        StockHightoLow: '在庫多→少',
        AlphabetAZ: 'アルファベットA-Z',
        AlphabetZA: 'アルファベットZ-A'
    },
    minimizeTitle: 'スキャナーがアクティブ',

    security_guarantee: {
        title: 'データセキュリティ保証'
    },

    invoice: {
        invoicePlaceholder: '請求書番号',
        invoiceTitle: '請求書',
        manageInvoiceAddress: '請求先住所を管理',
        selectOrManageAddresses: 'カスタム請求先住所を選択、編集、または作成',
        useBusinessProfileAddress: 'ビジネスプロフィールの住所を使用',
        noCustomAddressesFound: 'カスタム住所が追加されていません',
        createCustomAddressDesc: 'デフォルトのビジネスプロフィールデータの代わりに請求書に印刷するカスタム請求先または支店住所を追加してください。',
        defaultFromBusinessProfile: 'ビジネスプロフィールのデフォルト',
        editInvoiceAddress: '請求先住所を編集',
        createNewInvoiceAddress: '新しい請求先住所を作成',
        logoHeaderImage: 'ロゴ / ヘッダー画像',
        deleteInvoiceAddress: '請求先住所を削除しますか？',
        deleteAddressConfirmText: 'この請求先住所を削除してもよろしいですか？この操作は元に戻せません。'
    },

    ManageInvoiceAddress: '請求先住所を管理',
    SelectOrManageAddresses: 'カスタム請求先住所を選択、編集、または作成',
    UseBusinessProfileAddress: 'ビジネスプロフィールの住所を使用',
    CreateNewAddress: '新しい住所を作成',
    UpdatingList: 'リストを更新中...',
    NoCustomAddressesFound: 'カスタム住所が追加されていません',
    CreateCustomAddressDesc: 'デフォルトのビジネスプロフィールデータの代わりに請求書に印刷するカスタム請求先または支店住所を追加してください。',
    DefaultFromBusinessProfile: 'ビジネスプロフィールのデフォルト',
    EditInvoiceAddress: '請求先住所を編集',
    CreateNewInvoiceAddress: '新しい請求先住所を作成',
    LogoHeaderImage: 'ロゴ / ヘッダー画像',
    UploadingImage: '画像をアップロード中...',
    UploadImage: '画像をアップロード',
    BusinessName: '会社名',
    AddressDetails: '住所詳細',
    PhoneNumber: '電話番号',
    EmailAddress: 'メールアドレス',
    DeleteInvoiceAddress: '請求先住所を削除しますか？',
    DeleteAddressConfirmText: 'この請求先住所を削除してもよろしいですか？この操作は元に戻せません。',

    stocklowreport: {
        no_stocklowreport_one: '安全在庫設定のある商品はありません。',
        no_stocklowreport_two: '安全在庫数量を追加してください。',
        currentStock: '現在の在庫',
        safetyStock: '安全在庫',
        pricing: '価格設定',
        costPrice: '原価',
        sellingPrice: '販売価格',
        productInfo: '商品情報',
        category: 'カテゴリー',
        description: '説明',
        no_description: '説明は追加されていません',
        variants: 'バリエーション',
        unitsOnHand: '手持ち在庫数',
        minimumThreshold: '最小しきい値',
        adjust: '調整',
        all: 'すべて',
        lowStock: '在庫不足',
        variantsDetails: 'バリエーションの詳細',
        qty: '数量',
        addSafetyStock: '安全在庫を追加',
        searchByNameSku: '名前/SKUで検索',
        safetyStockShort: '安',
        warehouseSafetyStock: '倉庫の安全在庫'
    },

    low_alert_stock: '安全在庫数量を入力してください',

    lowStockAlertNotify:
        '設定した数量を下回ると在庫不足の通知を受け取ります',

    applyButtonStockAlert: '適用',
    cancelButtonStockAlert: 'キャンセル',
    searchProductLabel: '商品を検索...',
    successfullyAddedSafetyStock: '安全在庫を正常に更新しました',
    safety_Stock: '安全在庫',
    safety_stock_placeholder: '安全在庫を入力',

    lowStockDetailsInfo: {
        ProductCode: '商品コード',
        SafetyStock: '安全在庫',
        Stock: '在庫',
        CostPrice: '原価',
        SellingPrice: '販売価格',
        Category: 'カテゴリ',
        Description: '説明',
        ExpirationDate: '有効期限'
    },

    CustomLang: {
        Attribute: '属性',
        AddAttribute: '属性を追加',
        EditAttribute: '属性を編集',
        CustomLabePlaceholder: '属性名を入力',
        CustomLabePlaceholderSelect: 'タイプを選択',
        AddMoreAttribute: 'さらに属性を追加',
        ItemAttribute: 'アイテム属性',
        TableName: '名前',
        TableType: 'タイプ',
        TableAction: '操作',
        TableDelete: '削除',
        TableEdit: '編集',
        deleteMessage: '属性が正常に削除されました',
        editSuccessMessage: '属性が正常に更新されました',
        AddSuccessMessage: '属性が正常に追加されました',
        AddAtt: '追加',
        EditAtt: '編集',
        SubmitAtt: '送信中...'
    },

    Expenses: {
        ExpensesTitle: '経費',
        AddExpenses: '経費を追加',
        ExpenseCategory: '経費カテゴリ',
        NoExpenseCategory: '経費カテゴリがありません',
        AddExpenseCategory: '経費カテゴリを追加',
        SelectExpenseCategory: '経費カテゴリを選択',
        NoExpenses: '経費はありません',
        ExpensesSuccess: '経費が正常に作成されました',
        ExpensesSuccessEdit: '経費が正常に更新されました',
        ExpensesCategoryName: '経費カテゴリ名',
        ExpensesSuccessDelete: '経費が正常に削除されました',
        AddNEC: "新しい経費カテゴリを追加",
        NC: "新しい経費カテゴリ",
        EditNEC: "経費カテゴリを編集"
    },

    Manufacturing: {
        ProducedProduct: "製造品",
        QuantityManufactured: "製造数量",
        UnitCost: "単位コスト",
        RawMaterialsTotal: "原材料合計",
        TotalManufacturingCost: "製造総コスト",
        NoRawMaterialsConsumed: "原材料の消費はありません。",
        CostBreakdown: "コスト内訳",
        GeneratedBatch: "生成されたバッチ",
        StoredBinLocation: "保管場所",
        NoManufacturingTransactionsFound: "製造トランザクションが見つかりません",
        AddManufacture: '製造詳細を追加',
        Manufacturing: '製造',
        RawMaterials: '原材料',
        AdditonCosts: '追加費用',
        RawMaterial: '原材料',
        AdditonCost: '追加費用',
        TotalCost: '合計費用',
        AddRawMaterial: '原材料を追加:',
        AddAdditonCost: '追加費用を追加:',
        AddMore: 'さらに追加',
        Add: '追加',
        Update: '更新',
        Updating: '送信中...',
        ProductRequired: '商品は必須です',
        QuantityRequired: '数量は必須です',
        ChargeRequired: '費用は必須です',
        EstimatedCostRequired: '見積費用は必須です',
        PurchasePriceRequired: '仕入価格は必須です',
        SelectCharge: '費用を選択',
        EstimatedCost: '見積費用',
        SelectProduct: '商品を選択',
        Quantity: '数量',
        ManufactureDetails: '製造詳細',
        BuyingPrice: '仕入価格',
        LabourCharge: '労務費',
        ElectricityCost: '電気代',
        PackagingCharge: '梱包費',
        LogisticCost: '物流費',
        OtherCharges: 'その他の費用',
        Save: '詳細を保存',
        PurchasePrice: '仕入価格',
        Date: '日付',
        For: '対象',
        PurchaseRate: '仕入単価',
        Scrolltoloadmore: 'さらに読み込むにはスクロール...',
        Noproductsfound: '商品が見つかりません',
        ManufacturingQuantity: '製造数量',
        ManufactureAddedSuccess: '製造詳細が正常に更新されました'
    },

    Warehouses: {
        transferOrder: 'アイテム転送',
        AddTransferOrder: 'アイテム転送を追加',
        NewWarehouse: '新しい倉庫',
        newHead: '複数の倉庫を管理しましょう！',
        headTwo: '複数倉庫間で在庫をシームレスに追跡・管理できます',
        EnableWarehouse: '倉庫を有効化',
        EnableWarehouse2: '倉庫を有効にする',
        OrganizationPrimary: '組織のプライマリ',
        Edit: '編集',
        AreEnableWarehouse: '倉庫を有効にしてもよろしいですか？',
        Confirm: '確認',
        Cancel: 'キャンセル',
        WarehouseCreatedSuccessfully: '倉庫が正常に作成されました',
        MarkAsOP: '組織のプライマリとしてマーク',
        MarkAsInAct: '非アクティブとしてマーク',
        MarkAsAct: 'アクティブとしてマーク',
        MarkedAsInactive: '倉庫が非アクティブに設定されました',
        MarkedAsActive: '倉庫がアクティブに設定されました',
        MarkedAsOP: '倉庫がプライマリに設定されました',
        WareDeletedSuccess: '倉庫が正常に削除されました',
        SuccessfullyUpdatedWarehouse: '倉庫が正常に更新されました',
        SuccessfullyCreatedWarehouse: '倉庫が正常に作成されました',
        EditWarehouse: '倉庫を編集',
        AddWarehouse: '倉庫を追加',
        WarehouseNameIsRequired: '倉庫名は必須です',
        EnterWarehouseName: '倉庫名を入力してください',
        EnterEmail: 'メールを入力',
        EnterPhoneNumber: '電話番号を入力',
        Location: '場所...',
        name: '倉庫名',
        email: 'メール',
        phoneNumber: '電話番号',
        location: '場所',
        ViewProducts: '製品を見る',
        PageTitle: '倉庫',
        noWarehouse: "検索に一致する倉庫はありません"
    },

    Assets: {
        headerTitle: '資産',
        addAssetMessage:
            'ここで資産を追加します。スタッフに資産を割り当てるには、スタッフのプロフィールに移動してください。',
        addAsset: '資産を追加',
        editAsset: '資産を編集',
        assetCode: '資産コード',
        assetName: '資産名',
        assetCategory: '資産カテゴリ',
        assetType: '資産タイプ',
        serialNumber: 'シリアル番号',
        location: '場所',
        condition: '状態',
        selectCondition: '状態を選択',
        fair: '普通',
        good: '良好',
        excellent: '優良',
        poor: '不良',
        notes: 'メモ',
        submit: '送信',
        submitting: '送信中',
        noCategory: 'カテゴリなし',
        selectCategory: 'カテゴリを選択',
        addAssetCat: '資産カテゴリを追加',
        addAssetCatName: '資産カテゴリ名',
        edit: '編集',
        status: 'ステータス',
        createdAt: '作成日',
        viewAsset: '資産を見る',
        assignAsset: '資産を割り当て',
        conditionRet: '返却時の状態',
        searchSelectAssets: '資産を検索/選択',
        assetAssigned: '資産が正常に割り当てられました',
        assetReturned: '資産が正常に返却されました',
        selectAnAsset: '資産を選択してください',
        action: '操作',
        noAssetAssigned: '割り当てられた資産はありません',
        reAssigned: '再割り当て',
        assignedAssetsList: '割り当て済み資産リスト',
        viewHistory: "履歴を見る",
        history: "資産履歴",
        loadingHistory: "履歴を読み込み中...",
        loadingMore: "さらに読み込み中...",
        dateTime: "日付と時間",
        staff: "スタッフ",
        AssignedBy: "割り当て者",
        assign: "割り当て",
        return: "返却",
        unknown: "不明",
        noHistory: "この資産の履歴はありません。",
        enterReturnNote: "返却のメモを入力してください",
        returnNote: "返却メモ",
        enterAssignNote: "割り当てのメモを入力してください",
        assignNote: "割り当てメモ",
        AddNAC: "新しい資産カテゴリを追加",
        EditNAC: "資産カテゴリを編集",
        others: "その他"
    },

    LedgerTransaction: {
        ledgerDetails: '台帳詳細',
        productName: '商品名',
        totalQty: '合計数量',
        date: '日付',
        receivedAmt: '受取金額',
        paid: '支払済',
        discount: '割引',
        balance: '残高',
        more: 'もっと見る',
        total: '合計',
        ledgerupdatedsuccessfully: '台帳が正常に更新されました',
        ledgeraddedsuccessfully: '台帳が正常に追加されました',
        viewLedger: '台帳を見る',
        edit: '編集',
        create: '作成',
        Recieved: '受取 [入庫]',
        payMode: '支払方法',
        Refno: '参照番号'
    },

    ExtraField: {
        attachment: '添付ファイル',
        acceptOnlyImg: '画像のみ受け付けます。',
        addAttribute: '属性を追加',
        acceptImgAndDoc: '画像とドキュメントを受け付けます。'
    },

    phoneInvoiceDownload: {
        Variant: "バリエーション",
        Warehouse: "倉庫",
        Bin: "棚番",
        Batch: "バッチ",
        Attributes: "属性"
    },
    ImportExcel: {
        ImportStockfromExcel: "Excelから在庫をインポート",
        DragDrop: "記入済みのExcelファイルをここにドラッグ＆ドロップ、またはクリックして参照",
        DT: "テンプレートをダウンロード",
        GB: "戻る",
        Downloading: "ダウンロード中...",
        ChangeFile: "ファイルを変更",
        ReadingExcelfile: "Excelファイルを読み込み中...",
        Processing: "処理中...",
        submitUpdateStock: "送信して在庫を更新",
        downloadLatestTemplate: "最新テンプレートをダウンロード",
        loginRequired: "ログインが必要です"
    },
    stockForm: {
        recordPaymentNow: "今すぐ支払いを記録",
        recordPaymentDescCustomer: "顧客が支払った金額を入力してください",
        recordPaymentDescSupplier: "仕入先が支払った金額を入力してください",
        managePayments: "支払いを管理",
        invoice: "請求書",
        challan: "納品書",
        recordPayment: "支払いを記録",
        payableAmount: "支払金額",
        paidAmount: "支払済金額",
        paymentMethod: "支払い方法",
        paymentDate: "支払日",
        reference: "参照",
        billId: "請求番号",
        importExcel: "Excelからインポート",
        noThanks: "いいえ",
        checkHistory: "履歴を確認",
        wantViewHistory: "履歴を表示しますか？",
        enterPayable: "支払金額を入力",
        enterPaid: "支払済金額を入力",
        selectPayment: "支払い方法を選択",
        attachment: "添付ファイル",
        note: "メモ"
    },
    HistoryEdit: {
        products: "商品",
        add_product: "商品を追加",
        paidAmountInvalidMessage: "支払済金額は支払金額を超えることはできません",
        removingText: "この商品を削除すると、この取引で行われた在庫変更が元に戻ります。",
        remove: "削除"
    },
    ExcelProduct: {
        uploadFile: "ファイルをアップロード",
        dragDrop: "Excelファイルをドラッグ＆ドロップ、またはクリックしてアップロード。",
        parsingFile: "ファイルを解析中",
        fileSelected: "ファイルが選択されました",
        reviewImportedData: "以下のインポートされたデータを確認してください。可能な場合、列は自動的に一致されます。",
        changeFile: "ファイルを変更",
        back: "戻る",
        invalidFileType: "有効なExcelファイルをアップロードしてください (.xlsx または .xls)",
        parseExcelError: "Excel解析エラー:",
        noData: "アップロードされたExcelファイルにデータがありません。",
        failedToRead: "Excelファイルの読み取りに失敗しました。再試行してください。",
        Nodata: "データなし",
        unableToRead: "ファイルを読み取れません。",
        buyingMustNumber: "仕入価格は数値である必要があります",
        sellingMustNumber: "販売価格は数値である必要があります",
        mustBeNumber: "数値である必要があります",
        bulkUploadfailed: "一括アップロードに失敗しました",
        importFromExcel: "Excelからインポート",
        generating: "生成中...",
        downloadTemplate: "テンプレートをダウンロード",
        uploading: "アップロード中...",
        done: "完了",
        requiredField: "{field} は必須です",
        bulkUpload: "一括アップロード",
        duplicateSku: "重複したSKUが見つかりました",
        uploadedSuccessfully: "すべての商品が正常にアップロードされました！",
        uploadCompleteIssues: "問題ありでアップロードが完了しました",
        uploaded_products: "{count} 件の商品がアップロードされました。",
        failed_products: "{count} 件が失敗しました。",
        failed_items: "失敗した項目:"
    },
    Discount: {
        overallDiscount: "全体割引",
        final: "最終合計",
        balanceDue: "支払残高",
        tax: "税"
    },
    ProductForm: {
        barcodeQuantity: "バーコード数量を入力",
        baseUnit: "基本単位（主）",
        addSecondaryUnit: "副単位を追加しますか？",
        selectUnit: "単位を選択",
        subUnitDetails: "副単位の詳細",
        subUnit: "副単位",
        selectSubUnit: "副単位を選択",
        conversionRate: "換算率",
        exampleLogic: "例のロジック：",
        example: "ペンを箱で販売する場合、基本単位を箱に設定し、換算率50の副単位（個）を追加します。これは1箱に50個入っていることを意味します。",
        basePrice: "基本価格"
    },
    barcode: {
        settings: 'バーコード設定',
        labelSize: 'ラベルサイズ',
        customSize: 'カスタムサイズ...',
        widthMm: '幅 (mm)',
        heightMm: '高さ (mm)',
        showPrice: 'ラベルに販売価格を表示する',
        noPrices: 'この商品には販売価格が設定されていません。',
        preview: 'プレビュー',
        generate: '生成',
        label: 'ラベル',
        singlePage: 'シングルページ',
        downloadOptions: 'ダウンロードオプション',
        chooseLayout: 'バーコードのレイアウトを選択',
        allInSinglePage: 'すべてのバーコードを1ページに追加。',
        allInA4Grid: 'すべてシングルページ',
        allInA4GridSub: 'すべてのバーコードをA4グリッドに配置します',
        onePerPage: '1ページに1つ',
        onePerPageSub: '各バーコードを独自のラベルページに配置'
    },

    TransferItem: {
        transferItem: "商品移動",
        Date: "日付",
        Reason: "理由",
        enterReason: "理由を入力",
        Name: "名前",
        QuantityTransfered: "移動数量",
        SWarehouse: "元倉庫",
        SelectSWarehouse: "元倉庫を選択",
        DWarehouse: "先倉庫",
        SelectDWarehouse: "先倉庫を選択",
        CreatedBy: "作成者",
        CreatedTime: "作成時間",
        UpdatedTime: "更新時間",
        NoOrderFound: "注文が見つかりません",
        New: "新規",
        WarehouseItemTransfer: "倉庫商品移動",
        TotalTransfers: "合計転送数",
        EnterReason: "理由を入力",
        ItemDetails: "商品詳細",
        CurrentAvailable: "現在の在庫",
        TransferQty: "移動数量",
        SStock: "元在庫",
        DStock: "先在庫",
        addDescription: "商品説明を追加",
        selectVariant: "バリエーションを選択",
        addNewRow: "新しい行を追加",
        typeOrSelectItem: "検索するには入力",
        scrollToLoadMore: "スクロールしてさらに読み込む",
        noProductsFound: "商品が見つかりません",
        selectWarehouse: "倉庫を選択"
    },
    Sku: {
        searchSelectProduct: "商品を検索 / 選択",
        searchSelectSku: "SKUを検索 / 選択",
        noSkuFound: "SKUが見つかりません"
    },
    HistoryPage: {
        addFilter: "フィルター追加",
        filtersActive: "すべてのフィルターが有効",
        noProducts: "商品なし",
        download: "ダウンロード",
        recentlyUpdated: "最近更新",
    },
    StockPage: {
        challanNumber: "チャラン番号",
        subTotal: "小計",
        totalTaxes: "合計税額",
        taxInclusive: "税込",
        discountedValue: "割引額",
        taxValue: "税額",
        totalAmount: "合計金額",
        close: "閉じる",
        addTax: "税を追加",
        label: "ラベル",
        enterLabel: "ラベルを入力",
        taxRate: "税率",
        enterTaxRate: "税率を入力",
        selectTaxRate: "税率を選択",
        addNewTax: "新しい税率を追加",
        discountProducts: "割引額（商品）",
        taxProducts: "税額（商品）",
        clickAddPayment: "クリックして支払いを追加",
        paidGreaterPayable: "支払額は請求額を超えることはできません",
        vendorCompulsory: "支払いを記録するには仕入先が必要です",
        customerCompulsory: "支払いを記録するには顧客が必要です",
        updateInvoiceFormat: "請求書フォーマットを更新",
        updateChallanFormat: "チャランフォーマットを更新",
        addPrefix: "プレフィックスを追加",
        prefix: "プレフィックス"
    },
    EditHistoryPage: {
        search_by_notes: "メモで検索",
        alertMessage: "この変更は履歴にのみ記録され、現在の在庫には影響しません。",
        paymentDetails: "支払い詳細",
        units: "単位",
        customLabels: "カスタムラベル",
        value: "値",
        Order_Info: "注文情報",
        percentage: "パーセンテージ",
        Stock_updates_on_submit: "送信時に在庫を更新",
        Summary: "概要"
    },
    historyCard: {
        paid: "支払済み",
        partiallyPaid: "一部支払済み",
        billDate: "請求日",
        productDetails: "商品詳細",
        paymentsHistory: "支払い履歴",
        updatePayment: "支払いを更新",
        discounts: "割引",
        inclusive: "（税込）",
        discountOverall: "割引額（合計）",
        dueAmount: "未払金額",
        enterPaid: "支払額を入力",
        enterReference: "参照を入力",
        enterNote: "メモを入力",
        enterInvoice: "請求書を入力",
        enterChallan: "チャランを入力",
        edit: "編集済み"
    },
    printInvoice: {
        billTo: "請求先",
        ref: "参照番号",
        mode: "支払い方法",
        date: "日付",
        amount: "金額",
        totalPaid: "支払合計"
    },
    Contact: {
        supplier_required: "在庫入庫には仕入先が必要です",
        customer_required: "在庫出庫には顧客が必要です",
        key: "キー",
        editHistory: "履歴を編集",
        loading: "読み込み中..."
    },
    AW: {
        availablewarehouse: "利用可能な倉庫",
        visibilityManagement: '可視性管理',
        availablewarehouses: "利用可能な倉庫",
        Active: "アクティブ",
        LWarehouse: "倉庫を読み込み中...",
        NWForthisProduct: "この製品の倉庫が見つかりませんでした。",
        of: "の",
        WarehouseAvailabilty: "倉庫の可用性",
    },
    Currency: {
        searchCurrency: "通貨を検索...",
        addCurrency: "通貨を追加",
        addNewCurrency: "新しい通貨を追加",
        editCurrency: "通貨を編集",
        currencySymbol: "通貨記号",
        currencyName: "通貨名",
        enterCurrencySymbol: "通貨記号を入力",
        enterCurrencyName: "通貨名を入力"
    },
    NewReportLang: {
        DM: "日次移動",
        WR: "倉庫レポート",
        PDM: "製品日次移動",
        TBP: "総購入価格",
        TPQ: "総製品数量",
        TP: "総製品数",
        CS: "現在の在庫",
        IV: "在庫価値",
        DA: "日次平均",
        TSI: "総入庫数",
        TSO: "総出庫数",
        TOR: "回転率",
        Tv: "総価値",
        AST: "アクティブSKU追跡",
        UT: "追跡ユニット数",
        SL: "在庫レベル",
        Value: "価値",
        IO: "入庫/出庫",
        T: "回転",
        unitsD: "ユニット/日",
        Sort: "並べ替え",
        Sort_by: "並べ替え基準",
        Units_available: "利用可能なユニット",
        Units_unavailable: "利用不可のユニット",
        Current_assets: "流動資産",
        Search: "検索",
        available: "利用可能",
        assigned: "割り当て済み",
        AYSWD: "本当に削除しますか？",
        PTS: "倉庫が正常に転送されました",
        AUS: "資産が正常に更新されました",
        ACS: "資産が正常に作成されました",
        VSP: "販売価格を表示",
        HUS: "履歴が正常に更新されました",
    },
    ReplacementReturn: {
        selectProduct: "商品を選択してください",
        selectReplacementProduct: "少なくとも1つの代替商品を選択してください",
        validQuantity: "有効な返品数量を入力してください",
        replacedSuccessfully: "商品を正常に交換しました",
        returnSuccessfully: "商品を正常に返品しました",
        failedProcess: "処理に失敗しました。もう一度お試しください。",
        return: "返品",
        replace: "交換",
        typeSelectProduct: "商品を入力または選択...",
        returnQuantity: "返品数量",
        enterQuantity: "数量を入力",
        replacementDate: "交換日",
        returnDate: "返品日",
        chooseCustomer: "顧客を選択",
        additionalNotes: "追加のメモを入力...",
        replacementProducts: "代替商品",
        addProducts: "さらに商品を追加",
        tapSelect: "利用可能な商品から選択するにはタップ",
        currently: "現在",
        item: "アイテム",
        items: "アイテム",
        selected: "選択済み",
        selectedItems: "選択したアイテム",
        hideDetails: "詳細を隠す",
        showDetails: "詳細を表示",
        product: "商品",
        priceLevel: "価格レベルを選択",
        customPrice: "カスタム価格を入力",
        noReplaceHistory: "交換履歴が見つかりません",
        replaceReturn: "交換・返品",
        replaceReturnHistory: "交換・返品履歴"
    },
    OtherComponent: {
        mfgHistoryTitle: "製造履歴",
        mfgHistoryDesc: "製造された在庫製品を追跡",
        dailyOperation: "日常業務",
        freqUsed: "記録を素早く更新するためのよく使われるアクション",
        manageCategory: "カテゴリ管理",
        organizeCaterory: "商品、費用、資産のカテゴリを整理・管理",
        businessRecord: "ビジネス記録",
        organizeRecord: "ビジネス記録を整理・管理",
        trackHistory: "履歴を追跡",
        completeTracking: "監査と追跡のための完全な履歴",
        Verifyinventorycount: "在庫数を確認",
        Exchangerates: "為替レート",
        Productiontracking: "生産追跡",
        Fixedassetregister: "固定資産台帳",
        Storagelocations: "保管場所",
        warehouseAvailability: '倉庫レベルの製品可用性',
        Logreviewspend: "支出の記録と確認",
        Productgroupings: "商品グループ化",
        Classifyexpenditures: "支出の分類",
        Assetclassification: "資産分類",
        Manageexchanges: "為替管理",
        Returnauditlog: "返品監査ログ",
        Interlocationmoves: "拠点間移動",
        Manageoperationscategoriesrecordsandhistory: "業務、カテゴリ、記録、履歴の管理"
    },
    no_permission_dialog: {
        title: '権限がありません',
        historyDescription: "取引履歴を表示する権限がありません。管理者にお問い合わせください。",
        replacementHistoryDescription: "交換・返品履歴を表示する権限がありません。管理者にお問い合わせください。",
        transferHistoryDescription: "倉庫間転送履歴を表示する権限がありません。管理者にお問い合わせください。"
    },
    OthersHistory: {
        title: "履歴の管理",
        transferHistory: "転送履歴の管理",
        transactionHistory: "取引履歴の管理",
        replacementHistory: "交換・返品履歴の管理"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "ビジネスが共有した商品を閲覧して購入できます。",
        description: "ビジネスが共有した商品を閲覧できます。",
        productsAvailable: "利用可能な商品",
        noImageAvailable: "画像はありません",
        productDetails: "商品詳細",
        inStock: "在庫あり",
        availableVariants: "利用可能なバリエーション",
        options: "オプション",
        orders: "注文"
        ,
        searchProducts: "商品を検索...",
        noProductsFound: "商品が見つかりません",
        tryDifferentKeyword: "別のキーワードで検索してください",
        variants: "バリエーション",
        stock: "在庫",
        cart: "カート",
        products: "商品",
        viewCart: "カートを見る",
        backToProducts: "商品に戻る",
        yourCart: "カート",
        clear: "クリア",
        cartEmpty: "カートは空です",
        cartEmptyDesc: "カタログを閲覧して、注文したい商品を追加してください。",
        browseProducts: "商品を閲覧",
        selectedItems: "選択したアイテム",
        itemInCart: "アイテムがカートに",
        itemsInCart: "アイテムがカートに",
        customerDeliveryDetails: "顧客・配送情報",
        fullName: "氏名",
        enterFullName: "氏名を入力してください",
        deliveryAddress: "配送先住所",
        addressPlaceholder: "住所、建物名、市区町村、郵便番号...",
        orderNote: "注文メモ（任意）",
        orderNotePlaceholder: "特別な指示や配送メモ...",
        paymentMode: "支払い方法",
        subtotal: "小計",
        items: "アイテム",
        totalAmount: "合計金額",
        orderOnWhatsApp: "WhatsAppで注文 📲",
        orderPlaced: "注文が完了しました！🎉",
        orderPlacedDesc: "注文が記録され、WhatsAppが開かれました。",
        continueShopping: "買い物を続ける 🛍️",
        cartEmptyTitle: "カートが空です",
        cartEmptyToast: "チェックアウト前に商品をカートに追加してください。",
        incompleteTitle: "入力不完全",
        incompleteToast: "注文前にすべての必須項目を入力してください。",
        nameRequired: "氏名は必須です",
        addressRequired: "配送先住所は必須です",
        catalogUnavailable: "カタログは現在利用できません",
        catalogUnavailableDesc: "このカタログは現在アクティブではありません。",
        invalidCatalogLink: "無効なカタログリンク 🚫",
        invalidCatalogDesc: "このカタログページに必要な情報がありません。",
        missing: "不足",
        catalogSlug: "カタログスラグ",
        goBackHome: "ホームに戻る",
        inventoryManagement: "在庫管理と請求 🚀 Simply",
        enter: "入力",
        select: "選択",
        // Catalog Order translations
        catalogOrders: 'カタログ注文',
        pending: '保留中',
        converted: '変換済み',
        cancelled: 'キャンセル済み',
        totalRevenue: '合計金額',
        totalCatalogOrders: 'オンライン注文合計',
        convertToSalesOrder: '販売注文に変換',
        date: '日付',
        status: 'ステータス',
        action: '操作',
        searchOrders: '顧客名または電話番号を検索...',
        noMatchingOrders: '一致する注文がありません',
        noStatusOrders: '{status}の注文が見つかりません',
        tryDifferentSearch: '別の顧客名または電話番号で検索してみてください。',
        noOrdersWithStatus: '現在{status}ステータスの注文はありません。',
        noOrdersYet: 'カタログ注文はまだありません',
        noOrdersDescription: 'オンラインカタログからの注文がここに表示されます。',
        guestCustomer: 'ゲスト顧客',
        item: '商品',
        moreItems: '+{count}件',
        viewDetails: '詳細を見る',
        viewSalesOrder: '販売注文を見る',
        cancelOrder: '注文をキャンセル',
        confirmCancelTitle: 'カタログ注文をキャンセルしますか？',
        confirmCancelOrder: 'この注文をキャンセルしてもよろしいですか？この操作は元に戻せません。',
        keepOrder: 'いいえ、注文を保持',
        confirmCancelAction: 'はい、注文をキャンセル',
        orderNotFound: 'カタログ注文が見つかりません',
        orderNotFoundDescription: 'この注文が見つからないか、表示する権限がない可能性があります。',
        backToCatalogOrders: 'カタログ注文に戻る',
        placedOn: '注文日時',
        totalItems: '合計商品数',
        orderedProducts: '注文商品',
        itemDetails: '商品詳細',
        quantity: '数量',
        unitPrice: '単価',
        total: '合計',
        variant: 'バリエーション',
        customerInformation: '顧客情報',
        additionalFields: '追加項目',
        fields: '項目',
    },
    stockNew: {
        Npay: "まだ商品が追加されていません",
        emptydesc: "カタログから商品を選択し、入庫数量を入力して在庫を記録してください。",
        tipText: "ヒント：Excelファイルもアップロードできます",
        OT: "注文合計",
        Collapse: "折りたたむ"
    },
    deleteBulk: {
        Bulkoperation: "一括操作",
        Applyproducts: "複数の商品にアクションを適用",
        Bulkupload: "一括アップロード",
        ImportCSVfile: "ExcelまたはCSVファイルで商品をインポート",
        or: "または",
        Bulkdelete: "一括削除",
        Permanentlyallproducts: "すべての商品を永久に削除",
        IrrText: "一括削除は元に戻せません。必要に応じて先にバックアップをエクスポートしてください。",
        SeP: "選択した商品",
        sP: "商品を選択",
        DA: "すべて削除",
        DP: "商品を削除",
        sL: "すべて選択",
        ASDE: "を除くすべての商品を本当に削除しますか？",
        ASDAllP: "すべての商品を本当に削除しますか？",
        ASD: "本当に削除しますか",
        products: "商品",
        TACBU: "この操作は元に戻せません。",
        LP: "商品を読み込んでいます...",
        FM: "さらに読み込んでいます...",
        NPF: "商品が見つかりませんでした。",
        LMP: "さらに商品を読み込んでいます..."
    },
    NewVariantModal: {
        Definevariantsassign: "バリエーションを定義して数量を割り当て",
        Nothingallocated: "割り当てなし",
        Overallocated: "過剰割り当て",
        Fullyallocated: "完全に割り当て済み",
        Overby: "超過分",
        Allvariantsneedaname: "すべてのバリエーションに名前が必要です。",
        Reducequantities: "数量を減らしてください。",
        Overallocatedby: "過剰割り当て分",
        Quantitiesmustmatchthetotalavailability: "数量は合計在庫と一致する必要があります。",
        Allocatequantitiesacrosswarehouses: "倉庫間で数量を割り当て",
        Notfullydistributed: "完全に分配されていません：",
        remaining: "残り",
        Qty: "数量",
        Inactive: "非アクティブ",
        left: "残り"
    },
    ProductFormNew: {
        BasicInfo: "基本情報",
        ProductImage: "商品画像",
        Images: "画像",
        Pricing: "価格設定",
        Everypriceneedsbothalabelandanamount: "すべての価格にラベルと金額の両方が必要です",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '「卸売」や「小売」などのラベルを追加してこの価格を識別してください',
        AddMultiplePrice: "複数の価格を追加",
        NoPhotosLetAiFind: "写真がありませんか？AIに商品画像を探させましょう",
        AddProductImagesTitle: "商品画像を追加",
        ChooseHowToAddPhotos: "この商品の写真の追加方法を選択してください:",
        SearchWithAi: "AIで検索",
        SearchWithAiDesc: "AIを使って商品画像を自動で検索・選択",
        FilesFileExplorer: "ファイル（ファイルエクスプローラー）",
        FilesFileExplorerDesc: "パソコンから直接画像を選択",
        AiProductImageFinder: "AI商品画像ファインダー",
        AiProductImageFinderDesc: "商品の画像を検索・選択",
        TypeProductNamePlaceholder: "商品名を入力...",
        SearchForYourProduct: "商品を検索",
        SearchForYourProductHint: `ブランド名や商品名をお試しください例：「カークランド ミノキシジル」`,
        ImagesSelected: "件の画像を選択中",
        AddSelected: "選択した画像を追加"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "新しいカスタムフィールドを定義",
        AttributeName: "属性名",
        DataType: "データ型",
        Noattributesfound: "属性が見つかりません",
        ManageAttributes: "属性を管理",
        Editordeleteexistingattributes: "既存の属性を編集または削除",
        UpdateAttribute: "属性を更新",
        Saving: "保存中..."
    },
    NewExpenses: {
        Noexpensesyet: "まだ支出はありません",
        Addyourfirstexpensetostarttrackingyourspending: "最初の支出を追加して支出の追跡を開始しましょう。",
        TOTALEXPENSES: "合計支出",
        ENTRIES: "エントリー",
        BYCATEGORY: "カテゴリ別",
        Nocategoriestodisplay: "表示するカテゴリがありません",
        DateanfTime: "日付と時間"
    },
    PurchaseSales: {
        CancelOrder: "注文をキャンセル",
        ReopenOrder: "注文を再開",
        Reopen: "再開",
        ConfirmCancelOrder: "この注文をキャンセルしてもよろしいですか？",
        ConfirmReopenOrder: "この注文を再開してもよろしいですか？",
        OrderCancelledSuccessfully: "注文が正常にキャンセルされました。",
        OrderReopenedSuccessfully: "注文が正常に再開されました。",
        CancelledBy: "キャンセル者",
        Cancelled: "キャンセル済み",
        ConvertPriceBasedOnUnitConversion: "単位変換に基づいて価格を変換",
        MarkPaymentAsPending: "支払いを保留中としてマーク",
        PendingReceivableDesc: "売掛金として記録済み。入金時に支払いを記録してください。",
        PendingPayableDesc: "買掛金として記録済み。支払時に記録してください。",
        SelectCustomerFirst: "先に顧客を選択してください",
        SelectSupplierFirst: "先に仕入先を選択してください",
        SelectItemsFirst: "最初に少なくとも1つの商品を選択してください",
        PaymentMarkedPendingDesc: "支払いは保留中としてマークされています。今すぐ支払いを記録するには「支払いを保留中としてマーク」のチェックを外してください。",
        SelectCustomerAndItemFirst: "まず顧客と少なくとも1つのアイテムを選択してください",
        SelectSupplierAndItemFirst: "まず仕入先と少なくとも1つのアイテムを選択してください",
        SelectCustomerProductFirst: "まず顧客と商品を選択",
        SelectSupplierProductFirst: "まず仕入先と商品を選択",
        Receivables: "売掛金",
        Payables: "買掛金",
        AccessDenied: "アクセス拒否",
        YouDonthaeP: "このページを表示する権限がありません。間違いだと思われる場合は、管理者に連絡してください。",
        purchase: "仕入",
        sales: "販売",
        Areyousureyouwantto: "本当に実行しますか？",
        Thisactionwillupdateitsstatus: "この操作によりステータスが更新されます。",
        ReasonOPtional: "理由（任意）",
        Enterareasonfor: "理由を入力してください（",
        optionalDot: "任意）...",
        Reject: "拒否",
        ConfirmOrder: "注文確定",
        RejectOrder: "注文拒否",
        Previous: "前へ",
        First: "最初",
        Order: "注文",
        Items: "商品",
        Memo: "メモ",
        SelectDateRange: "日付範囲を選択",
        List: "リスト",
        Board: "ボード",
        View: "表示",
        CreateSalesOrder: "販売注文を作成",
        CreatePurchaseOrder: "仕入注文を作成",
        successfully: "成功しました",
        ManageAttachments: "添付ファイルの管理",
        Stockoutitemsimmediatelyaftersaving: "保存後すぐに在庫を出庫します。",
        Stockinitemsimmediatelyaftersavingthisorder: "この注文保存後すぐに在庫を入庫します。",
        ViewAttachments: "添付ファイルを見る",
        MemoAttachments: "メモ＆添付ファイル",
        ReceivedDate: "受領日",
        ShippedDate: "出荷日",
        OrderDate: "注文日",
        OrderDetails: "注文詳細",
        Subtotal: "小計",
        OrderSummary: "注文概要",
        AddItem: "商品を追加",
        NewSalesOrder: "新規販売注文",
        NewPurchaseOrder: "新規仕入注文",
        Createandmanageyour: "作成・管理",
        orders: "あなたの注文",
        Removeitem: "商品を削除",
        UnitPrice: "単価",
        PurchaseOrder: "仕入注文",
        SalesOrder: "販売注文",
        PurchaseInvoice: "仕入請求書",
        SalesInvoice: "販売請求書",
        PurchaseOrdernotfound: "仕入注文が見つかりません",
        Approve: "承認",
        MarkasShipped: "出荷済みにする",
        MarkasReceived: "受領済みにする",
        Marking: "マーク中...",
        PartiallyShip: "一部出荷",
        PartiallyReceive: "一部受領",
        Deleting: "削除中...",
        Transaction: "取引",
        Details: "詳細",
        Item: "商品",
        Received: "受領",
        Shipped: "出荷",
        Ordered: "注文済",
        units: "単位",
        Overalldiscount: "全体割引",
        Transactions: "取引履歴",
        Notransactionsfound: "取引が見つかりません",
        OrderedQty: "注文数量",
        Totalqty: "合計数量",
        StockingOut: "出庫中...",
        StockingIn: "入庫中...",
        thiorderUpdateStuau: "この注文？この操作でステータスが更新されます。",
        TransactionDetails: "取引詳細",
        Fetchingtransactiondetails: "取引詳細を取得中...",
        Nodetailsfoundforthistransaction: "この取引の詳細が見つかりません。",
        TotalBreakDown: "合計内訳",
        ChangeAmount: "お釣り金額",
        Attachments: "添付ファイル",
        PoNumber: "発注番号",
        SoNumber: "受注番号",
        partner: "パートナー",
        EditPurchase: "仕入を編集",
        EditSales: "販売を編集",
        PurchaseOrderDetails: "仕入注文の詳細",
        SalesOrderDetails: "販売注文の詳細",
        OrderType: "注文タイプ",
        SelectOrderType: "注文タイプを選択",
        OrderTypePrepaid: "前払い",
        OrderTypeCOD: "代金引換",
        OrderTypePayLater: "後払い",
        OrderTypePartialPayment: "一部支払い",
        OrderTypeSubscription: "サブスクリプション",
        viewAvailabilty: '空き状況を見る',
        NotReceived: "未受領",
        NotShipped: "未出荷",
        PartiallyReceived: "一部受領済み",
        PartiallyShipped: "一部出荷済み",
    },
    PriceReference: {
        HighPrice: "最高価格",
        LowPrice: "最低価格",
        LastPrice: "最終価格",
        LastPurchasePrice: "最終購入価格",
        Nopricerecordsfound: "価格記録が見つかりません",
        BuyingPriceReference: "仕入価格参照",
        SellingPriceReference: "販売価格参照",
        Viewstockinpricesfortheselectedvendorandproduct: "選択した仕入先と商品の入庫価格を表示",
        Viewstockoutpricesfortheselectedcustomerandproduct: "選択した顧客と商品の出庫価格を表示"
    },
    SubscriptionLocale: {
        premiumPlan: "プレミアムプラン",
        heading: "ビジネス上の意思決定を",
        headingHighlight: "データに基づいて",
        subtitle: "ビジネス分析のフルパワーを解放 — 制限なし、妥協なし。",
        choosePlan: "プランを選択",
        monthly: "月額",
        annual: "年額",
        oneTime: "ワンタイム (月額)",
        perMonth: "／月",
        perYear: "／年",
        bestValue: "おすすめ",
        continueWith: "続ける",
        perMonthShort: "月",
        perYearShort: "年",
        troubleWithSubscription: "サブスクリプションに問題がありますか？",
        contactUs: "お問い合わせ",
        paymentNotReady: "支払いの準備ができていません",
        checkoutError: "チェックアウトエラー",
        pricePreviewError: "価格プレビューエラー",
        subNotAvailable: "サブスクリプションは利用できません",
        subNotAvailableDesc: "現在、お住まいの国ではウェブサブスクリプションは利用できません。モバイルアプリから登録するか、サポートまでお問い合わせください。"
    },
    SubscriptionLocale2: {
        GoPro: "Pro にアップグレード",
        Makesmarterdecisionsbackedbyrealbusinessdata: "実際のビジネスデータに基づいたより賢い意思決定を",
        ExploreProPlans: "Proプランを探索"
    },
    emptyWarehouseState: {
        tips: [
            "異なる物理的な場所に対して複数の倉庫を持つことができます",
            "各商品は倉庫ごとに独立して在庫を追跡します",
            '「倉庫間移動」を使用して場所間で在庫を移動できます'
        ],
        NoWarehousesConfigured: "倉庫が設定されていません",
        desc: "まず倉庫を追加してください（複数ある場合）、次に商品を追加して在庫移動を記録します。",
        WarehouseSetupTips: "倉庫設定のヒント",
        Noproductselected: "商品が選択されていません",
        Selectaproductfromthelefttoviewlowstockdetails: "在庫不足の詳細を表示するには、左側から商品を選択してください。",
        Chooseaproductfromthelist: "リストから商品を選択",
        SelectProduct: "商品を選択",
        SetQuantity: "数量を設定",
        Showing: "表示中",
        products: "商品",
        Continue: "続ける",
        SaveSafetyStock: "安全在庫を保存",
        SafetyStockSaved: "安全在庫を保存しました！",
        hasbeensetto: "に設定されました",
        AddAnother: "もう一つ追加",
        Chooseaproduct: "商品を選択",
        Step: "ステップ",
        of: "/",
        Setsafetyquantity: "安全数量を設定",
        Complete: "完了",
        SafetyStockQuantity: "安全在庫数量",
        Minimumunitsdropsbelowthisnumber: "常に在庫に保持する最小単位数。この数を下回るとアラートが発生します。",
        NewSafetyStock: "新しい安全在庫",
        SafetyNow: "現在の安全在庫",
        SettingTo: "設定先",
        Change: "変更",
        sell: "販売",
        cost: "原価",
        BulUD: "一括アップロード/削除"
    },
    SimplyLoginUI: {
        sslEncryption: "256-bit SSL暗号化",
        dataPrivate: "あなたのデータは100%プライベートです",
        worksOnDevices: "Android & iPhoneで動作",
        realTimeSync: "全デバイスでリアルタイム同期",
        cloudBackup: "自動クラウドバックアップ",
        availableOn: "Web、Android、iOSで利用可能",
        tagline: "あなたの在庫、",
        taglineEm: "美しくシンプルに。",
        subtitle: "在庫管理、売上追跡、ビジネスをスムーズに進めるためにサインイン — すべて1か所で。",
        feature1Title: "リアルタイム在庫追跡",
        feature1Desc: "各倉庫に何があるか正確に把握 — 常に最新。",
        feature2Title: "販売・仕入注文",
        feature2Desc: "請求書を作成し、仕入先を管理し、すべての取引を追跡。",
        feature3Title: "スマートレポート",
        feature3Desc: "財務、在庫、日次移動のレポートを一目で。",
        feature4Title: "全デバイスでリアルタイム同期",
        feature4Desc: "スマホでの変更がWebに即反映 — その逆も。",
        rating1: "評価",
        rating2: "4.9/5",
        rating3: "10,000の卸売企業による",
        brandName: "Simply",
        greeting: "またお会いしました！👋",
        noPasswordNeeded: "在庫にアクセスするにはサインイン — Android、iPhone、Webすべて同期。",
        badge1: "在庫管理",
        badge2: "売上追跡",
        badge3: "レポート",
        trustEncryptedTitle: "暗号化済み",
        trustEncryptedSub: "256-bit SSL",
        trustPrivateTitle: "プライベート",
        trustPrivateSub: "あなたのデータのみ",
        trustBackedTitle: "バックアップ済み",
        trustBackedSub: "毎日自動",
        availableOnLabel: "対応プラットフォーム",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "全デバイスがリアルタイムで即座に同期",
        securityNote: "100%安全。",
        securityDesc: "銀行レベルの暗号化がすべてのデータを保護します。私たちが読むのは名前とメールのみ — 他は何も、決して。",
        signingIn: "サインイン中…",
        termsPrefix: "サインインすることでSimplyの",
        privacyPolicy: "プライバシーポリシー",
        and: "および",
        termsOfService: "利用規約",
        google: "Googleでログイン"
    },
    BatchLocal: {
        BatchName: "バッチ名",
        EnterBatchName: "バッチ名を入力",
        EnterNotes: "メモを入力",
        ExpiredDate: "有効期限",
        Selectexpireddate: "有効期限を選択",
        BatchStatus: "バッチステータス",
        CreatedDate: "作成日",
        Areyousureyouwanttodeletethisbatch: "このバッチを削除してもよろしいですか？",
        Youhavencreatedanybatchforthisproduct: "この商品のバッチはまだ作成されていません。",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "最初のバッチを作成して、ロットと有効期限で在庫を追跡し始めましょう。",
        Nobatchesyet: "まだバッチがありません",
        Whatisbatchmanagement: "バッチ管理とは？",
        Howithelpsyourbusiness: "ビジネスにどのように役立つか",
        Trackbylotnumber: "ロット番号で追跡",
        Trackbylotnumberdesc: "製造元のバッチごとに在庫をグループ化することで、どのロットからユニットが来たのか常に把握できます。",
        Expirydatecontrol: "有効期限管理",
        Expirydatecontroldesc: "在庫が期限切れになる前にアラートを受け取ります。古いバッチを先に販売し、無駄を自動的に削減します。",
        Fulltraceability: "完全なトレーサビリティ",
        Fulltraceabilitydesc: "すべての取引でどのバッチが使用されたかを正確に確認できます — 監査やリコールに最適です。",
        Supplierwisestock: "サプライヤー別在庫",
        Supplierwisestockdesc: "同じ商品でも異なるサプライヤーの在庫を分離します。バッチごとに品質を比較できます。",
        Createyourfirstbatchbutton: "最初のバッチを作成",
        Nomatchesfound: "一致する結果が見つかりません",
        NomatchesfounddescBefore: "",
        NomatchesfounddescAfter: " に一致するバッチが見つかりませんでした。",
        Clearsearch: "検索をクリア",
        Nohistoryfoundthisbatch: "このバッチの履歴が見つかりません",
        ComprehensiveDetails: "詳細情報",
        History: "履歴",
        InBatch: "バッチ内",
        Noproductfoundinthisbatch: "このバッチに商品が見つかりません",
        SelectBatch: "バッチを選択",
        available: "利用可能",
        Searchbatches: "バッチを検索...",
        Expires: "期限切れ",
        Nobatchesfound: "バッチが見つかりません",
        ManageBatches: "バッチを管理",
        Batchmanagement: "バッチ管理",
        Trackstockexpiry: "バッチと有効期限で在庫を追跡",
        Turnoffbatchmanagement: "バッチ管理をオフにしますか？",
        Yourgsafe: "既存のバッチデータは安全に保持されます。",
        Reenableanytimefrom: "いつでも",
        Otherstab: "その他タブから",
        AddBatch: "バッチを追加",
        Total: "合計",
        AssignProduct: "商品を割り当て",
        EditProductAssignment: "商品割り当てを編集",
        AssignProducttoBatch: "商品をバッチに割り当て",
        Updateproductconfiguration: "商品設定を更新",
        Step1of2: "ステップ 1/2",
        Step2of2: "ステップ 2/2",
        Selectvariantwarehouse: "バリエーションと倉庫を選択",
        SelectedProduct: "選択した商品",
        AssignQuantity: "数量を割り当て",
        BatchInfo: "バッチ情報",
        Wecouldnthisproductidentifier: "この製品識別子に関連するバッチが見つかりませんでした。",
        NoActiveBatches: "アクティブなバッチがありません",
        Endofresults: "結果の終了",
        Expiry: "有効期限",
        BatchManagementDescription: "ロット番号と有効期限で在庫を追跡します。すべての在庫出荷において正しいLIFO / FEFO順序を保証します。手動での選択は不要です。",
        Expiryalerts: "有効期限アラート",
        Autonotifications: "自動通知",
        LIFOsorting: "LIFO / FEFOソート",
        Smartstockflow: "スマートな在庫フロー",
        Perout: "バッチごとの在庫出荷",
        Precisiontracking: "精密追跡",
        NeedsReview: "レビューが必要",
        Pending: "保留中",
        Rejected: "却下されました",
        Approved: "承認済み",
        WaitingForApproval: "承認待ち",
        WaitingForApprovalDesc: "オーナーがまもなくこのバッチを確認し、承認します。",
        BatchRejected: "バッチが却下されました",
        BatchRejectedDesc: "オーナーがこのバッチを却下しました。",
        Reason: "理由",
        Approve: "承認",
        Reject: "却下",
        ConfirmApproveTitle: "バッチを承認",
        ConfirmRejectTitle: "バッチを却下",
        ConfirmApprovalAction: "このバッチを{action}してもよろしいですか？この操作によりステータスが更新されます。",
        ReasonOptional: "理由（任意）",
        EnterReasonPlaceholder: "{action}の理由を入力してください（任意）",
        Processing: "処理中...",
        BatchActivatedSuccess: "バッチが正常に有効化されました",
        BatchDeactivatedSuccess: "バッチが正常に無効化されました",
        BatchDeletedSuccess: "バッチが正常に削除されました",
        BatchApprovedSuccess: "バッチが正常に承認されました",
        BatchRejectedSuccess: "バッチが正常に却下されました",
        SearchByBatchName: "バッチ名で検索...",
        YesTurnOff: "はい、オフにする",
        KeepItOn: "オンのままにする"
    },
    CategoryNewL: {
        TotalCategories: "総カテゴリ数",
        lastaddedcategory: "最後に追加したカテゴリ",
        acrossalltypes: "すべてのタイプで",
        MostRecent: "最新",
        YesD: "はい、削除します",
        AllAssociated: "関連するすべての製品に影響が出る可能性があります"
    },
    OverDas: {
        movestockbetweenlocations: "在庫を移動",
        no_activity_yet: "まだ活動がありません",
        no_activity_sub: "販売、仕入、在庫移動、返品がここにリアルタイムで表示されます。",
        make_first_sale: "最初の販売を行う",
        add_stock: "在庫を追加",
        all_stock_healthy: "すべての在庫レベルは健全です",
        all_stock_healthy_sub: "在庫不足の商品はありません。商品に最低閾値を設定するとここにアラートが表示されます。",
        set_stock_thresholds: "在庫閾値を設定",
        no_warehouses_setup: "倉庫が設定されていません",
        no_warehouses_setup_sub: "在庫の保管場所を追跡し、ロケーションを管理するために倉庫を追加してください。",
        add_first_warehouse: "最初の倉庫を追加",
        Customer: "顧客",
        PurchasevsSales: "仕入 vs 販売",
        Financialperformancechart: "財務パフォーマンスチャート",
        QuickActions: "クイックアクション",
        Frequentlyused: "よく使う機能",
        Addinventory: "在庫を追加",
        Dispatchitems: "商品を出荷",
        Addorder: "注文を追加",
        Newitem: "新しい商品",
        Inventoryaccess: "在庫アクセス",
        Itemsneedingreorder: "再注文が必要な商品",
        Latesttransactions: "最新の取引",
        Operationalsummary: "運用サマリー",
        ViewAll: "すべて表示",
        Manage: "管理",
        RecentActivity: "最近の活動",
        LowStockAlerts: "低在庫アラート",
        Primary: "メイン",
        TotalWarehouses: "倉庫総数"
    },
    SerialLocal: {
        ShowOrHideFields: "フィールドの表示と非表示",
        ShowOrHideFieldsDesc: "以下の項目をタップして、印刷される請求書に追加または削除します。変更はすぐに適用されます。",
        Manufacturesettings: "製造設定",
        Showbuyingprice: "仕入価格 / 製品コスト",
        Showadditionalcost: "追加コスト",
        Costbreakdown: "コスト内訳",
        Unitcost: "単位コスト",
        Rawmaterialstotal: "原材料合計",
        Confirmentry: "入力確認",
        SaveSerials: "シリアル番号を保存",
        SerialNumber: "シリアル番号",
        selected: "選択済み",
        added: "追加済み",
        Serialnumbers: "シリアル番号",
        ResetAll: "すべてリセット",
        Wecouldnfindthis: "この製品の利用可能なシリアル番号が見つかりませんでした。",
        Nounitsfound: "ユニットが見つかりません",
        Searchingserialnumbers: "シリアル番号を検索中...",
        Scanorenterstock: "新しい在庫のシリアルをスキャンまたは入力",
        Whataserialnumber: "シリアル番号とは？",
        Auniqueidentifieryourinventorylifecycle: "ユニットごとの固有識別子 — 在庫ライフサイクル全体を通じて各アイテムを個別に追跡できます。",
        Trackedstockout: "追跡済み出庫",
        Chooseexactlyselected: "出荷するシリアル番号を正確に選択してください。この製品で入庫済みのシリアルのみが表示されます — 選択すると数量がロックされます ",
        SelectSerialstoout: " - 出庫するシリアルを選択",
        Thisinvoicegeneratedusingwwwsimplstockco: "この請求書は www.simplstock.co を使用して生成されました",
        AuthorizedSignature: "承認済み署名",
        Invoicesettings: "請求書設定",
        Draw: "描画",
        Taptoselectordeselectitems: "タップして項目を選択/解除",
        Thissignaturewillbeadded: "この署名は印刷された請求書の最下部に追加されます。",
        SignatureOptions: "署名オプション",
        Upload: "アップロード",
        DrawSignature: "署名を描く",
        UploadSignature: "署名をアップロード",
        Clear: "クリア",
        ShowStaffName: "スタッフ名",
        ShowSKU: "SKU",
        ShowBusinessName: "会社名",
        ShowProductName: "商品名",
        ShowBusinessPhoneNumber: "ビジネス電話番号",
        ShowBusinessEmail: "ビジネスメール",
        ShowBusinessAddress: "ビジネス住所",
        ShowProductImage: "商品画像",
        ShowPaymentDetails: "支払い詳細",
        ShowCategory: "カテゴリ",
        ShowVariant: "バリエーション",
        ShowWarehouse: "倉庫",
        ShowAttributes: "属性",
        ShowQuantity: "数量",
        ShowDiscount: "割引",
        ShowTax: "税",
        ShowPrice: "価格",
        ShowTotalPrice: "商品合計価格",
        ShowExpenses: "費用",
        ShowSignature: "署名",
        ShowNote: "メモ",
        showAttachment: "添付ファイル",
        ShowSerialNumber: "シリアル番号",
        Invoicesettingsapplied: "請求書設定を適用しました。変更を確認してください。",
        EnterSerialNumber: "シリアル番号を入力",
    },
    FewLocal: {
        SelectBin: "ビンを選択",
        Live: "ライブ",
        Monitorinventorystocklevels: "在庫、移動、在庫レベルを監視",
        StockControlCentre: "在庫管理センター",
        Nochartdataavailable: "チャートデータがありません",
        Disabled: "無効",
        Enabled: "有効"
    },
    Bin: {
        Bin: "ビン",
        Add: "追加",
        NoBinsAddedYet: "まだビンが追加されていません",
        BinLocationsHelp: "ビン位置を使用すると、この倉庫内の正確な位置で在庫を追跡できます — もう探す必要はありません。",
        NameThemByPosition: "位置で名前を付けてください:",
        AddBinLocation: "ビン位置を追加",
        BinLocations: "ビン位置",
        BinNameRequired: "ビン名は必須です",
        EditBin: "ビンを編集",
        AddBin: "ビンを追加",
        EnterBinName: "ビン名",
        EnterBinNamePlaceholder: "ビン名を入力",
        BinStatus: "ビンの状態",
        BinNotes: "メモ",
        EnterBinNotesPlaceholder: "メモを追加...",
        ViewInventory: "在庫を表示",
        Inventory: "在庫",
        TrymatchingadifferentSKUname: "別のSKUまたは名前で試してください。",
        Thisbinlocationcurrentlyempty: "このビン位置は現在空です。",
        Loadingbins: "ビンを読み込み中...",
        bins: "ビン",
        ManageBin: "ビンを管理",
        Print: "印刷",
        SBin: "移動元Bin",
        DBin: "移動先Bin"
    },
    WarehouseExcel: {
        title: "倉庫 & ビン位置をアップロード",
        description: "以下の手順に従って、Excelファイルを使用して倉庫とそのビン位置を一括作成します。",
        bulkUploadGuide: "一括アップロードガイド",
        step1: "ステップ 1",
        downloadTemplate: "Excelテンプレートをダウンロード",
        downloadTemplateDesc: "必要なすべての列ヘッダーが設定済みの公式テンプレートをダウンロードしてください。列名を変更・削除しないでください。",
        downloadTemplateBtn: "テンプレートをダウンロード",
        step2: "ステップ 2",
        fillExcelFile: "Excelファイルを入力",
        fillExcelDesc: "1行が1つの倉庫を表します。すべての列を入力してください — ビン位置は <code>Bin Names</code> 列にカンマ区切りで入力します。",
        step3: "ステップ 3",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "アップロード前に、以下のルールに従っていることを確認してください。",
        step4: "ステップ 4",
        uploadYourFile: "ファイルをアップロード",
        uploadDesc: "入力完了後、下記からファイルをアップロードしてください。システムが自動的に倉庫とビン位置を作成します。",
        rules: ["倉庫ごとに1行のみ", "ビン名は1つのセルにカンマ区切り", "列ヘッダー名を変更しない Japanese", "同じ倉庫内の重複ビン名はスキップ", "国コード付き電話番号", ".xlsx または .xls ファイルのみ対応"],
        dropFileHere: "ここにExcelファイルをドロップ",
        supports: "対応形式: .xlsx / .xls — 最大10MB",
        chooseFileUpload: "ファイルを選択してアップロード",
        parsing: "ファイルを解析中...",
        invalidFileType: "無効なファイル形式です。Excelファイルをアップロードしてください。",
        noData: "Excelにデータが見つかりません",
        failedToRead: "Excelファイルの読み込みに失敗しました",
        unableToRead: "ファイルを読み込めません。",
        reviewTitle: "倉庫データの確認",
        reviewSubtitle: "ビジネスにインポートする前の最終確認です。",
        changeFile: "ファイルを変更",
        rowsFound: "行見つかりました",
        cancel: "キャンセル",
        finalizeImport: "確定してインポート",
        importing: "インポート中...",
        success: "成功",
        allWarehouseUploadedSuccess: "すべての倉庫が正常にアップロードされました",
        failed: "失敗",
        bulkUploadFailed: "一括アップロードに失敗しました",
        error: "エラー",
        binNamesNote: "<strong>Bin Names</strong> 列では、倉庫ごとのすべてのビン位置を1つのセルにカンマ区切りで入力してください — 例: A1, A2, B1, RACK-01。",
        headers: { warehouseName: "倉庫名", email: "メールアドレス", phoneNumber: "電話番号", location: "場所", binNames: "ビン名" }
    },
    VariantTemplate: {
        VariantTemplates: "バリエーション テンプレート",
        Managereusablevariantpatterns: "再利用可能なバリエーションパターンを管理",
        BinTransferHistory: "Bin 移動履歴",
        Trackmovementsacrossbins: "Bin間の移動を追跡",
        SerialNumberHistory: "シリアル番号履歴",
        Trackproductserialnumberactivity: "製品シリアル番号の活動を追跡",
        Period: "期間",
        Nohistoryfound: "履歴が見つかりません",
        Searchserialnumbers: "シリアル番号を検索...",
        SerialNumbersHistory: "シリアル番号履歴",
        Serialnumberhistoryglance: "シリアル番号履歴を一目で確認。",
        Noserialnumbersfound: "シリアル番号が見つかりません",
        Noactivityhistoryfound: "活動履歴が見つかりません",
        Statussetto: "ステータスを変更",
        Timeline: "タイムライン",
        Managereusableproductvariantpatterns: "再利用可能な製品バリエーションパターンを管理。",
        DeleteTemplate: "テンプレートを削除",
        Areyousureyouwanttemplate: "このテンプレートを削除してもよろしいですか？",
        CreateNewTemplate: "新しいテンプレートを作成",
        CreateTemplate: "テンプレートを作成",
        EditTemplate: "テンプレートを編集",
        UnlimitedTemplates: "無制限のテンプレート",
        CreateAsManyTemplates: "必要なだけテンプレートを作成 — 衣類、靴、電子機器など。",
        PickWhileAddingProduct: "商品追加時に選択",
        OpenTemplateLibrary: "テンプレートライブラリを開いて、数秒でバリエーション名を選択。",
        MixFromMultipleTemplates: "複数のテンプレートから組み合わせ",
        SelectFromMultipleTemplates: "1つの商品に対して複数のテンプレートからバリエーション名を選択 — 完全に柔軟。",
        EditAnytime: "いつでも編集",
        RenameTemplatesAnytime: "カタログが変わったらテンプレート名を変更したり、バリエーション名を追加・削除したりできます。",
        StayConsistent: "一貫性を保つ",
        SameVariantNamesAcrossAll: "すべての商品で同じバリエーション名。タイプミス、重複、推測なし。",
        BuildOnceUseEverywhere: "一度作れば、 どこでも使用可能",
        StopReEnteringVariantNames: "毎回同じバリエーション名を入力するのをやめましょう。テンプレートを作成して割り当て、すぐに再利用。",
        Updateexistingvariantcombinations: "既存のバリエーション組み合わせを更新",
        Definenewvariantcombinations: "新しいバリエーション組み合わせを定義",
        TemplateName: "テンプレート名",
        AddVariantOptions: "バリエーションオプションを追加",
        SmallMedium: "例: S, M...",
        VariantsList: "バリエーション一覧",
        Nooptionsaddedyet: "まだオプションが追加されていません",
        SaveTemplate: "テンプレートを保存",
        egSizesColorsetc: "例: Tシャツサイズ、カラーなど",
        Pleaseentertemplatename: "テンプレート名を入力してください",
        Pleaseaddatleastonevariantoption: "少なくとも1つのバリエーションオプションを追加してください",
        Templateupdatedsuccessfully: "テンプレートを更新しました",
        Templatecreatedsuccessfully: "テンプレートを作成しました",
        Failedtosavetemplate: "テンプレートの保存に失敗しました",
        Transfer: "移動",
        Editassignment: "割り当てを編集",
        Updateproductdetailsinbin: "Bin内の商品情報を更新",
        Editinginbin: "Bin内で編集中",
        ConfirmUpdate: "更新を確認",
        ConfirmAssign: "割り当てを確認",
        Assignanotherproduct: "別の商品を割り当てる",
        TransferBin: "Binを移動",
        SourceBin: "移動元Bin",
        DestinationBin: "移動先Bin",
        SelectSourceBin: "移動元Binを選択",
        SelectDestinationBin: "移動先Binを選択",
        Unit: "単位",
        ManageVariant: "バリエーションを管理",
        CreateSKUvariationsyourproduct: "商品のSKUバリエーションを作成",
        Assigningvariationsto: "バリエーションを割り当て中",
        Novariantsaddedyet: "まだバリエーションが追加されていません",
        AddedVariants: "追加したバリエーション",
        AddVariantsfromTemplate: "テンプレートからバリエーションを追加",
        Pickatemplateandselectvariantnames: "テンプレートを選択してバリエーション名を選択",
        ChooseaTemplate: "テンプレートを選択",
        Selectvariantnamestoadd: "追加するバリエーション名を選択",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "バリエーション名を選択するテンプレートを選んでください。複数から追加可能です。",
        Loadingtemplates: "テンプレートを読み込み中...",
        Backtotemplates: "テンプレートに戻る",
        Selectallindividualadd: "すべてまたは個別にバリエーション名を選択して追加。",
        VariantNames: "バリエーション名",
        MediaDescription: "メディア & 説明",
        Addattachmentsandproductnotes: "添付ファイルと商品メモを追加",
        ProductMedia: "商品メディア"
    },
    AddProductGuide: {
        title: "保存後に初期在庫を追加",
        description: "ここでは製品に数量フィールドはありません。保存後、「在庫入庫」を使用して初期在庫を登録してください — 場所と追跡を完全にコントロールできます。",
        steps: {
            quantity: { title: "数量", sub: "初期在庫数を設定" },
            binLocation: { title: "Bin位置", sub: "通路、ラック、棚 — 例: A-01-03" },
            serialNumbers: { title: "シリアル番号", sub: "各ユニットを個別に追跡" },
            warehouse: { title: "倉庫", sub: "どの場所に保管されているか" },
            batchExpiry: { title: "バッチ / 有効期限", sub: "バッチ番号で在庫をグループ化" }
        },
        actions: { close: "閉じる" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "転送オーダーが見つかりません",
        Itemshistory: "倉庫間で移動した商品は、ここに追跡と履歴として表示されます。",
        CreateTransfer: "転送を作成"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "製造する製品をタップ",
        Selectproductfrombelow: "下のリストから製品を選択",
        SetupANewProduct: "新しい製品をセットアップ",
        DefineAProductAdditsrawmaterial: "製品を定義し、原材料を追加する",
        ManufacturingSetup: "製造セットアップ",
        Pickproducttodefineitsproductiondetails: "製品を選んで生産詳細を定義",
        ConfigureManufacturing: "製造を構成",
        SelectRawMaterial: "原材料を選択",
        NoRawMaterials: "原材料なし",
        Definecomponentsneededtoproduct: "この製品の製造に必要なコンポーネントを定義します。",
        NoAdditionalCosts: "追加コストなし",
        Addlaboroverheadlogisticalcharges: "労務費、間接費、または物流費を追加します。",
        AddAdditionalCost: "追加コストを追加",
        AddCost: "コストを追加",
        TotalPrice: "合計価格",
        SelectCharges: "料金を選択",
        EnterEstimatedCost: "見積コストを入力",
        QtyRequried: "必要数量",
        Manufacturing: "製造",
        Outputfinishedgoodsdestination: "完成品の保管先",
        Manufacturingquantity: "製造数量",
        Storefinishedgoodsat: "完成品の保管場所",
        Rawmaterials: "原材料",
        StockSelection: "在庫選択",
        AdditionalCosts: "追加コスト",
        Quantityconsume: "消費数量",
        Totalmanufacturingcost: "合計製造コスト",
        Sumofrawmaterialcosts: "すべての原材料コストの合計",
        CustomManufacturingCharge: "カスタム製造料金",
        Addextralikelaboroverheadrepairs: "労務費、間接費、修理費などの追加費用を追加します。",
        CalculatedTotal: "計算された合計",
        AddRawMaterial: "原材料を追加",
        ConfigureRawMaterial: "原材料を構成",
        Thisoutputunit: "これは、出力ユニットあたりの基本必要数量です。",
        ChangeProduct: "製品を変更",
        AddtoList: "リストに追加",
        ManufacturedSuccessfully: "製造が成功しました",
        Manufacture: "製造",
        EditDeleteHistory: "編集/削除履歴",
        ManageOrder: "注文管理",
        ManageBatch: "バッチを管理",
        Paymentnotavailablehere: "ここでは支払いできません",
        Thisrecordisanorderorderitself: "このレコードは注文からのものです。支払いは注文からのみ記録できます。",
        Torecorpaymenttheorderthethere: "支払いを記録するには、リンクされた注文に移動し、そこで<b>支払い記録</b>オプションを使用してください。",
        GotoOrder: "注文へ移動"
    },
    CustomerExcel: {
        title: "顧客の一括アップロード",
        description: "以下の手順に従って、Excelファイルを使用して顧客を一括作成します。",
        bulkUploadGuide: "一括アップロードガイド",
        step1: "ステップ 1",
        downloadTemplate: "Excelテンプレートをダウンロード",
        downloadTemplateDesc: "必要なすべての列ヘッダーが設定された公式テンプレートを入手します。",
        downloadTemplateBtn: "テンプレートをダウンロード",
        step2: "ステップ 2",
        fillExcelFile: "Excelファイルを記入",
        fillExcelDesc: "各行が1人の顧客を表します。必要に応じてすべての列を記入してください。",
        step3: "ステップ 3",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "アップロードする前に、エラーを避けるためにファイルが以下のルールに従っていることを確認してください。",
        step4: "ステップ 4",
        uploadYourFile: "ファイルをアップロード",
        uploadDesc: "記入後、以下にファイルをアップロードしてください。システムが自動的にすべての顧客を作成します。",
        rules: [
            "顧客ごとに1行のみ",
            "列ヘッダーの名前を変更しないでください",
            "国コード付きの連絡先番号",
            ".xlsxまたは.xlsファイルのみ受け付け可能"
        ],
        dropFileHere: "ここにExcelファイルをドロップしてください",
        supports: ".xlsxおよび.xlsをサポート — 最大10MB",
        chooseFileUpload: "ファイルを選択してアップロード",
        parsing: "ファイルを解析中...",
        invalidFileType: "無効なファイル形式です。Excelファイルをアップロードしてください。",
        noData: "Excel内にデータが見つかりません",
        failedToRead: "Excelファイルの読み取りに失敗しました",
        unableToRead: "ファイルを読み取れません。",
        reviewTitle: "顧客データの確認",
        reviewSubtitle: "ビジネスにインポートする前の最終確認です。",
        changeFile: "ファイルを変更",
        rowsFound: "行が見つかりました",
        cancel: "キャンセル",
        finalizeImport: "完了してインポート",
        importing: "インポート中...",
        success: "成功",
        allCustomerUploadedSuccess: "すべての顧客が正常にアップロードされました",
        failed: "失敗",
        bulkUploadFailed: "一括アップロードに失敗しました",
        error: "エラー",
        headers: {
            customerName: "顧客名",
            phoneNumber: "連絡先",
            address: "住所",
            note: "メモ"
        }
    },
    SupplierExcel: {
        title: "サプライヤーの一括アップロード",
        description: "以下の手順に従って、Excelファイルを使用してサプライヤーを一括作成します。",
        bulkUploadGuide: "一括アップロードガイド",
        step1: "ステップ 1",
        downloadTemplate: "Excelテンプレートをダウンロード",
        downloadTemplateDesc: "必要なすべての列ヘッダーが設定された公式テンプレートを入手します。",
        downloadTemplateBtn: "テンプレートをダウンロード",
        step2: "ステップ 2",
        fillExcelFile: "Excelファイルを記入",
        fillExcelDesc: "各行が1社のサプライヤーを表します。必要に応じてすべての列を記入してください。",
        step3: "ステップ 3",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "アップロードする前に、エラーを避けるためにファイルが以下のルールに従っていることを確認してください。",
        step4: "ステップ 4",
        uploadYourFile: "ファイルをアップロード",
        uploadDesc: "記入後、以下にファイルをアップロードしてください。システムが自動的にすべてのサプライヤーを作成します。",
        rules: [
            "サプライヤーごとに1行のみ",
            "列ヘッダーの名前を変更しないでください",
            "国コード付きの連絡先番号",
            ".xlsxまたは.xlsファイルのみ受け付け可能"
        ],
        dropFileHere: "ここにExcelファイルをドロップしてください",
        supports: ".xlsxおよび.xlsをサポート — 最大10MB",
        chooseFileUpload: "ファイルを選択してアップロード",
        parsing: "ファイルを解析中...",
        invalidFileType: "無効なファイル形式です。Excelファイルをアップロードしてください。",
        noData: "Excel内にデータが見つかりません",
        failedToRead: "Excelファイルの読み取りに失敗しました",
        unableToRead: "ファイルを読み取れません。",
        reviewTitle: "サプライヤーデータの確認",
        reviewSubtitle: "ビジネスにインポートする前の最終確認です。",
        changeFile: "ファイルを変更",
        rowsFound: "行が見つかりました",
        cancel: "キャンセル",
        finalizeImport: "完了してインポート",
        importing: "インポート中...",
        success: "成功",
        allSupplierUploadedSuccess: "すべてのサプライヤーが正常にアップロードされました",
        failed: "失敗",
        bulkUploadFailed: "一括アップロードに失敗しました",
        error: "エラー",
        headers: {
            supplierName: "サプライヤー名",
            phoneNumber: "連絡先",
            bankName: "銀行名",
            accountHolderName: "口座名義",
            accountNumber: "口座番号",
            note: "メモ"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "交換先",
        Noreplacementhistoryfound: "交換履歴が見つかりません",
        Noreturnhistoryfound: "返品履歴が見つかりません",
        Productbeingreturned: "返品対象の商品",
        Required: "必須",
        Selectreturnedproduct: "返品された商品を選択",
        Searchnamescanbarcode: "名前、SKUで検索、またはバーコードをスキャン",
        Browse: "参照",
        Stockhandling: "在庫入庫処理",
        Stockinreturnedproduct: "返品商品を在庫に入れる",
        Ontoinventory: "オン — 返品された商品は在庫に再追加されます",
        Offreturnedonly: "オフ — 商品は返品としてのみ記録されます",
        Usedrestock: "再入荷時の利益調整の計算に使用されます",
        Willaddedbackconfirmation: "確認後、在庫に再追加されます",
        Returnreason: "返品理由",
        Optional: "任意",
        SelectReason: "理由を選択",
        Additionalnotes: "追記",
        Describeofcustomerexplanation: "返品商品の状態、目に見える損傷、顧客の説明などを記述してください...",
        Requiredmustfilledcontinue: "続行するには必須項目を入力する必要があります",
        Reviewdetailsbeforeconfirming: "確認前に詳細を確認してください",
        Replacementproductwilldeductedinventoryconfirmation: "交換商品は確認後、在庫から差し引かれます。",
        Choosereplacementproduct: "交換商品を選択",
        Willdeductedfrominventoryconfirm: "確認後、在庫から差し引かれます",
        Thesewillattachedothereturnrecord: "これらの画像は返品記録に添付されます",
        Replacementitem: "交換アイテム",
        Addanotherproduct: "別の商品を追加",
        Replacementproductwillbe: "交換商品は確認後、在庫から",
        deducted: "差し引かれ",
        fromyourinventoryconfirmation: "ます。",
        productadjustedusingprice: "返品された商品は再入荷され、元の販売価格を使用して利益が調整されます。",
        Willloggedreturnedonlynotrestocked: "返品としてのみ記録されます — 再入荷はされません",
        Returnonly: "返品のみ",
        Imagesofreturnedproduct: "返品商品の画像",
        Returnedproductwill: "返品商品は再入荷されず、",
        not: "返品として",
        berestockedloggedreturnedonly: "のみ記録されます。",
        AddImage: "画像を追加",
        STOCKIN: "在庫入庫",
        LOGONLY: "記録のみ",
        ContinuetoReview: "確認へ進む →",
        Confirmreplacement: "交換を確定",
        Confirmreturn: "返品を確定",
        Filldetailsbelowproceed: "続行するには以下の詳細を入力してください",
        Review: "確認",
        editdetails: "詳細を編集",
        Configurereturndetails: "返品詳細を構成",
        Configurereplacementdetails: "交換詳細を構成",
        SelectSource: "ソースを選択",
        Returning: "返品中",
        Replacement: "交換",
        WalkCustomer: "飛び込み客",
        RETURNEDPRODUCT: "返品された製品",
        REPLACEMENTPRODUCT: "交換製品",
        STOCKOUT: "在庫出庫",
        Netinventoryimpact: "純在庫への影響",
        Replacementitemcost: "交換アイテムのコスト",
        Returneditemrestockvalue: "返品アイテムの再入荷価値",
        PROFITINVENTORYSUMMARY: "利益と在庫の概要",
        Inventoryaction: "在庫アクション",
        Valuededucted: "差し引かれた価値",
        Profitadjustment: "利益調整",
        stockedout: " 出庫済み",
        restocked: " 再入荷済み",
        Noaction: "アクションなし",
        Valuebeingreturned: "返品される価値",
        Willberestocked: "再入荷されます",
        Willbe: "されます",
        logged: "記録",
        ON: "オン",
        OFF: "オフ",
        Linked: "リンク済み",
        Pleaseselectreturnedproduct: "返品商品を選択してください",
        Quantityrequired: "数量は必須です",
        Buyingpricerequired: "仕入れ価格は必須です",
        Pleaseaddleastreplacementproduct: "少なくとも1つの交換商品を追加してください",
        Pleaseconfigurereturnedproductdetails: "返品商品の詳細を設定してください",
        Pleaseselectcustomer: "顧客を選択してください",
        Returndateisrequired: "返品日付は必須です",
        Pleasefillallrequiredfields: "すべての必須項目を入力してください",
        Wildeductedfrominventory: "在庫から差し引かれます",
        Currentprice: "現在の価格",
        Defectivedamaged: "不良品 / 破損",
        Wrongitemreceived: "誤った商品を受け取った",
        Customerchangedmind: "お客様が気が変わった",
        Sizefitissue: "サイズ / フィットの問題",
        Notasdescribed: "説明と異なる",
        Other: "その他",
        Originalsaleprice: "元の販売価格 (利益調整済)",
        Addedbackinventory: "在庫に再度追加",
        Notaddedinventory: "在庫に追加されていません",
        replacedwith: "に置き換え",
        deductedfrominventory: "在庫から差し引かれました",
        RETURNWITHSTOCKIN: "返品 · 在庫入",
        RETURNNOSTOCKIN: "返品 · 在庫入なし",
        MULTIPLEREPLACEMENTS: "複数交換",
        SINGLEREPLACEMENT: "単一交換",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "返却済 · 在庫入",
        REPLACEMENTSTOCKOUT: "交換 · 在庫出",
        Returnonlylogsthisentry: "返品はこのエントリのみを記録します —",
        nostockwillbeaddedorremoved: "在庫の追加や削除は行われません",
        frominventory: "在庫から。",
        Whentousethis: "いつこれを使用するか:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "販売のために発送されたが、破損していたり使用不可能で戻ってきた商品を記録するために、一日の終わりに「返品」を使用します。これらは追跡したいが、在庫に戻すことができない商品です。",
        Youcanviewallpastreturnentriesin: "過去のすべての返品エントリは、次の場所で確認できます",
        ReturnHistory: "返品履歴",
        underthe: "下の",
        Others: "その他",
        tab: "タブ。",
        Negativestocktransactiondisabled: "マイナスの株式取引は無効化されています。"
    },
    NewRLocal: {
        Originalsaleprice: "元の販売価格",
        Editinghistoryonlyinventorystaysunchanged: "履歴のみを編集しています — 在庫は変更されません。",
        Changeshereupdatethisdetailsquantitiesaffected: "ここでの変更は、このレコードの詳細（理由、日付、メモ）のみを更新します。実際の在庫数、棚番、および製品データは影響を受けません。",
        Needtofixinventorylevelsinstead: "代わりに在庫レベルを修正する必要がありますか？",
        AdjustStock: "在庫を調整",
        Refund: "返金",
        ImportantNote: "重要な注意事項",
        Pleasereviewbeforecontinuing: "続行する前に確認してください",
        Onceshippedreceivedanyupdatesmadeorder: "注文が出荷または受領されると、注文に加えられた更新は取引履歴に反映されません。",
        Thisundone: "これにより、注文が完全に削除されます。この操作は取り消せません。",
        Inventorywilladjustedautomatically: "在庫は自動的に調整されません",
        Deletingthisreversevedshippedyouwillneed: "これを削除しても、在庫の変更は取り消されません。アイテムが既に受領/出荷されている場合は、以下が必要になります",
        reflectthecorrectstocklevels: "正しい在庫レベルを反映させるため。",
        manuallyadjustyourinventory: "在庫を手動で調整する",
        Addremovestockforitemsthatwereshipped: "出荷されたアイテムの在庫を追加/削除する",
        Addremovestockforitemsthatwerereceived: "受領されたアイテムの在庫を追加/削除する",
        Updatecostrecordspaymentwaalreadymade: "支払いが既に完了している場合は、コストレコードを更新する",
        Reconcilerecordsandoutstandingpayments: "記録と未払金の照合を行う"
    },
    ReceivablesLocal: {
        Receivables: "売掛金",
        Manageandtrackcustomerduebalances: "顧客の未払い残高を管理・追跡",
        Viewcustomerduebalancereport: "顧客未払い残高レポートを表示",
        Viewsupplierduebalancereport: "仕入先未払い残高レポートを表示",
        DueBalance: "未払い残高",
        Unpaid: "未払い",
        PartiallyPaid: "一部支払済み",
        Paid: "支払済み",
        HighestBalance: "最高残高",
        LowestBalance: "最低残高",
        Filldetailsrecordpayment: "支払いを記録するために詳細を入力",
        NewPaymentEntry: "新しい支払いエントリ",
        EditPaymentEntry: "支払いエントリを編集",
        Nosuppliersfound: "仕入先が見つかりません",
        Nocustomersfound: "顧客が見つかりません",
        LowtoHigh: "低い順",
        HightoLow: "高い順",
        AttachmentUploadedSc: "添付ファイルのアップロードに成功しました",
        AttachmentUploadedF: "添付ファイルのアップロードに失敗しました",
        Pay: "支払う",
        NoBillsFound: "請求書が見つかりません",
        Thiscustomerhasunpaidbills: "この顧客には未払いの請求書はありません。",
        TotalDue: "合計未払い額",
        BillsFound: "請求書が見つかりました",
        DeselectAll: "すべて選択解除",
        SelectAll: "すべて選択",
        ShowDetails: "詳細を表示"
    },
    AssetsNewLocal: {
        Assignedon: "割り当て日",
        Total: "合計",
        Assigned: "割り当て済み",
        Remaining: "残り",
        Available: "利用可能",
        NoSerialNumbers: "シリアル番号なし",
        UpdateExistingAssetDetails: "既存の資産詳細を更新",
        RegisterNewBusinessAsset: "新規ビジネス資産を登録",
        BasicInformation: "基本情報",
        AssetDetails: "資産の詳細",
        Quantity: "数量",
        SerialNumbers: "シリアル番号",
        SerialNumberPlaceholder: "シリアル番号",
        AddSerialNumber: "シリアル番号を追加",
        SerialNumbersOptional: "シリアル番号は任意です。最大で追加可能：",
        AssetImages: "資産画像",
        AdditionalNotes: "追加ノート",
        AdditionalNotesPlaceholder: "その他の詳細やメンテナンス履歴など...",
        Updating: "更新中...",
        Adding: "追加中...",
        ITEquipmentPlaceholder: "例：IT機器",
        LoadingMoreActivities: "さらにアクティビティを読み込んでいます...",
        AssignedAssets: "割り当てられた資産",
        Noassetsassignedstaffmember: "このスタッフに割り当てられた資産はありません。",
        Assignassetstaff: "スタッフに資産を割り当てる",
        Returnassetfromstaff: "スタッフからこの資産を返却",
        AssignmentDetails: "割り当て詳細",
        Serial: "シリアル",
        ViewAssets: "すべての資産を表示",
        ViewByStaff: "スタッフ別に表示",
        AssignedHistory: "割り当て履歴",
        Returned: "返却済み",
        Returnedon: "返却日",
        ReturnedBy: "返却者",
        AssignedTo: "割り当て先",
        NoHistoryRecords: "履歴レコードなし",
        Selectstaffmemberviewtheirassets: "資産を表示するスタッフを選択してください",
        Deleted: "削除済み",
        searchPlaceholder: "名前またはシリアル番号で資産を検索..."
    },
    InventoryCountLocale: {
        InventoryCount: "在庫カウント",
        Viewinventorycountreport: "在庫カウントレポートを表示",
        ItemsCount: "アイテム数",
        All: "すべて",
        InProgress: "進行中",
        Submitted: "送信済み",
        awaitingreview: "レビュー待ち",
        EditInventoryCount: "在庫カウントを編集",
        NewInventoryCount: "新しい在庫カウント",
        Modifyinventorycountsheetdetails: "在庫カウントシートの詳細を修正",
        Startanewinventorycountsheet: "新しい在庫カウントシートを開始",
        GeneralInformation: "基本情報",
        Title: "タイトル",
        SaveChanges: "変更を保存",
        Selectproductsforthisinventorycountsheet: "このシートの製品を選択",
        InventoryCountDetails: "在庫カウント詳細",
        Inventorycountsheetdetails: "在庫カウントシート詳細",
        Viewingdetailsforcountsheet: "カウントシートの詳細を表示中",
        Started: "開始済み",
        TaskSheets: "タスクシート",
        Allitems: "すべてのアイテム",
        NotStarted: "未開始",
        Completed: "完了",
        Results: "結果",
        ViewResults: "結果を表示",
        DeleteInventoryCount: "在庫カウントを削除",
        Viewingtransactionandadjustments: "トランザクションログと在庫調整を表示",
        Productsadjusted: "調整された製品",
        Assignee: "担当者",
        Tasksheetdetails: "タスクシート詳細",
        Draft: "下書き",
        VariantQuantities: "バリアント数量",
        AssignedProducts: "割り当てられた製品",
        ReturnAsset: "資産を返却",
        EditTasksheet: "タスクシートを編集",
        NewTasksheet: "新しいタスクシート",
        Updatetasksheetdetails: "タスクシートの詳細を更新",
        Starttasksheetforthisinventorycount: "この在庫カウントの新しいタスクシートを開始",
        TaskSheetInformation: "タスクシート情報",
        SheetTitle: "シートタイトル",
        Entersheettitle: "シートタイトルを入力",
        SubmissionResult: "提出結果",
        ReviewChanges: "変更を確認",
        Viewingsubmissionresultsforthisinventorycount: "この在庫カウントの提出結果を表示",
        Reviewyourinventorycountbeforesubmitting: "提出する前に在庫カウントを確認してください"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "カウントの読み込みに失敗しました",
        NoInventoryCounts: "在庫カウントなし",
        NoMatches: "一致なし",
        Therearenoinventorycountswiththestatus: "このステータスの在庫カウントはありません",
        Noinventorycountsfoundyoursearchterm: "検索語に一致する在庫カウントが見つかりません",
        Thereareinventorycountsrecordedyetforthisbusiness: "この事業の在庫カウントはまだ記録されていません"
    },
    StockinModalP: {
        StockInNow: "今すぐ在庫入庫",
        Settheopeningquantityforthisproductrightnow: "この商品の初期数量を今すぐ設定してください。",
        Addinitialstock: "初期在庫を追加しますか？",
        dothislater: "後でやります",
        Productadded: "商品が追加されました！",
        isready: "準備完了です。",
        SeeHowItWorks: "使い方を見る",
        NoSalesOrdersFound: "販売注文が見つかりません",
        NoPurchaseOrdersFound: "仕入注文が見つかりません",
        Startcreatingoutgoinginventoryrevenue: "販売注文を作成して、出庫在庫と収益を追跡し始めましょう。",
        Trackrestockssupplierplace: "在庫補充と仕入先注文を1か所で追跡します。",
        CreateSalesOrder: "販売注文を作成",
        CreatePurchaseOrder: "仕入注文を作成",
    }
    ,
    dialy_report: "日次移動レポート",
    Quotation: "見積もり",
    Quote: "見積もり",
    Assignee: "担当者",
    dayStart: "1日の開始",

    ShowTotalAmount: "合計金額",


    tutorial: {
        watchTitle: 'ステップバイステップのチュートリアルを見る',
        watchDesc: 'YouTubeチャンネルでSimplyStockを学ぶ',
        modalTitle: 'SimplyStockで先を行く',
        modalDesc: 'サブスクライブして、新しいチュートリアルをドロップした瞬間に入手しましょう',
        feature1Title: '新機能のウォークスルー',
        feature1Sub: '新しいアップデートのたびに短いビデオで説明するので、新しいことを見逃すことはありません',
        feature2Title: '簡単なハウツービデオ',
        feature2Sub: '在庫、請求書、スタッフアクセスなどを5分以内に設定',
        feature3Title: 'インスタント通知',
        feature3Sub: '新しいチュートリアルが公開された瞬間に通知を受け取る—自分のペースで学ぶ',
        feature4Title: 'いつでも100 ％無料',
        feature4Sub: 'すべてのチュートリアルは永久に無料です—ログインやサブスクリプションは必要ありません',
        subscribeBtn: 'SimplyStockに登録する',
        maybeLater: 'たぶん後で'
    }
    ,
    dailyCashReport: {
        "title": "日次現金レポート",
        "subtitle": "誰が何をいつ支払い、何が未払いか — 販売詳細からグループ化。",
        "totalSales": "総売上高",
        "cashReceived": "受取総額",
        "outstanding": "未払い",
        "collectionRate": "回収率",
        "grandTotalAllDates": "総合計（全日付）",
        "totalLabel": "合計",
        "loading": "読み込み中...",
        "noData": "指定された期間のデータは見つかりませんでした。",
        "loadingMore": "さらに読み込み中..."
    },
    dailyCashReportColumns: {
        "date": "日付",
        "customer": "顧客",
        "productsSold": "販売商品",
        "products": "商品",
        "salesAmount": "売上金額",
        "sales": "売上",
        "received": "受取総額",
        "receivedShort": "受取",
        "debited": "元帳への借方",
        "due": "未払い",
        "paymentModes": "支払方法",
        "mode": "方法"
    }
}



export default ja
